<template>
  <div
    style="width: 100%; height: 100%"
    fluid
    v-if="showLayout"
    :class="[isClonePattern ? 'clone-pattern-bv' : '', 'bv-example-row bv-example-row-flex-cols']"
    :style="containerStyle"
    @click.stop.prevent="layoutClick()"
  >
    <!-- 删除掉外层的点击不然选中侧边栏时directions会被改为0 -->
    <!-- @click.stop="titleClick(directions[0])" -->
    <div
      @drop="handleColsDragover($event, 0)"
      @dragover.stop.prevent="dragoverEv($event, 0)"
      @dragleave.prevent="dragoverLeaveEv($event, 0)"
      @click="titleClick(directions[0])"
      class="other_content"
      v-show="options.titleOptions[0].isShow"
      :style="{ height: options.titleOptions[0].height + 'px' }"
      :class="[options.titleOptions[0].type, isDragover !== 0 ? '' : 'isDrag-over']"
      @mouseenter.stop="otherMouseEnter"
      @mouseleave.stop="otherMouseLeave"
    >
      <vueDragResizable
        v-for="(elementOption, index) in options.titleOptions[0].elementOptions"
        v-show="elementOption.isShow"
        :class="[
          `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_0-elementInLayoutId_${elementOption.elementInLayoutId}`,
          elementOption.isActive ? 'active' : ''
        ]"
        :key="'layoutComponent' + index"
        :data-innerElement="'element is:' + elementOption.innerElement"
        :parentW="getParentW"
        :parentH="options.titleOptions[0].height"
        :w="Number(elementOption.options.width)"
        :h="Number(elementOption.options.height)"
        :x="Number(elementOption.options.left)"
        :y="Number(elementOption.options.top)"
        :isLayoutTitle="true"
        :parent="true"
        :zoom="zoom"
        :direction="Number(directions[0])"
        :elementInLayoutId="elementOption.elementInLayoutId"
        :elementName="elementOption.innerElement"
        :active="elementOption.isActive"
        :options="elementOption.options"
        :rectId="myid.rect_id"
        :shape="elementOption.innerElement"
        :draggable="elementOption.draggable && !isResizing"
        v-on:dragging="draggingEv"
        v-on:resizing="resizingEv"
        v-on:resizeStop="resizestopEv"
        v-on:dragStop="dragstopEv"
        v-on:activated="activeEv"
        v-on:deactivated="deactive"
        v-on:delElement="delElementEv"
        @refLineParams="getRefLineParams($event, Number(directions[0]))"
        @click.stop.prevent
        @mouseup.stop.prevent
        @mousedown.stop.prevent
        :myId="{ ...myid, elementInLayoutId: elementOption.elementInLayoutId, directionIndex: Number(directions[0]) }"
      >
        <component
          class="rect"
          v-if="elementOption.isShow"
          :options="elementOption.options"
          :myid="{ ...myid, elementInLayoutId: elementOption.elementInLayoutId, directionIndex: Number(directions[0]) }"
          :is="elementOption.innerElement"
        >
        </component>
      </vueDragResizable>
      <!--辅助线-->
      <template v-for="(lineOption, index6) in lineList">
        <span
          class="ref-line v-line"
          v-for="item in lineOption.vLine"
          :key="'vLine' + item.id + index6"
          v-show="item.display && Number(directions[0]) == index6"
          :style="{
            left: item.position,
            top: item.origin,
            height: item.lineLength
          }"
        />
        <span
          class="ref-line h-line"
          v-for="item in lineOption.hLine"
          :key="'hLine' + item.id + index6"
          v-show="item.display && Number(directions[0]) == index6"
          :style="{
            top: item.position,
            left: item.origin,
            width: item.lineLength
          }"
        />
      </template>
      <!--辅助线END-->
      <!--拖拽线-->
      <div
        class="custom-handle"
        :class="['custom-handle-' + options.titleOptions[0].type, resizingTitleIndex === 0 ? 'show' : '']"
        draggable="true"
        @mousedown.stop="
          $myDrag(
            {
              ctx: _self,
              dragStart: e => changeHeightMouseDownEv(e, 0),
              dragging: e => changeHeightDarg(e, 0, options.titleOptions[0].type),
              dragEnd: e => changeHeightMouseUpEv(e, 0, options.titleOptions[0].type, true)
            },
            $event
          )
        "
        :style="getHandleStyle(options.titleOptions[0])"
      >
        <span v-if="resizingTitleIndex === 0" class="size-popover">{{ "H: " + options.titleOptions[0].height }}</span>
      </div>
    </div>
    <div class="content_otherLR" :style="getContentHeight">
      <div v-show="isDrawerModeL && options.titleOptions[2].isShow">
        <el-drawer
          v-if="showDrawer"
          @dragover.stop.prevent="dragoverEv($event, 2)"
          @dragleave.prevent="dragoverLeaveEv($event, 2)"
          @drop.native="handleColsDragover($event, 2)"
          @click.native="titleClick(directions[2])"
          :size="options.titleOptions[2].width"
          direction="ltr"
          :visible.sync="drawerL"
          :with-header="false"
          :append-to-body="inBodyL"
          :modal-append-to-body="inBodyL"
          :class="isDragover !== 2 ? '' : 'isDrag-over'"
        >
          <div
            class="other_content"
            v-show="isDrawerModeL === false && options.titleOptions[2].isShow"
            :style="{ width: options.titleOptions[2].width + 'px' }"
            :class="options.titleOptions[2].type"
            @mouseenter.stop="otherMouseEnter"
            @mouseleave.stop="otherMouseLeave"
          >
            <vueDragResizable
              v-for="(elementOption, index) in options.titleOptions[2].elementOptions"
              v-show="elementOption.isShow"
              :key="'layoutComponent' + index"
              :class="[
                elementOption.isActive ? 'active' : '',
                `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_2-elementInLayoutId_${elementOption.elementInLayoutId}`
              ]"
              :data-innerElement="'element is:' + elementOption.innerElement"
              :parentW="options.titleOptions[2].width"
              :parentH="getParentH"
              :w="Number(elementOption.options.width)"
              :h="Number(elementOption.options.height)"
              :x="Number(elementOption.options.left)"
              :y="Number(elementOption.options.top)"
              :isLayoutTitle="true"
              :parent="true"
              :zoom="zoom"
              :direction="Number(directions[2])"
              :elementInLayoutId="elementOption.elementInLayoutId"
              :elementName="elementOption.innerElement"
              :active="elementOption.isActive"
              :options="elementOption.options"
              :rectId="myid.rect_id"
              :shape="elementOption.innerElement"
              :draggable="elementOption.draggable && !isResizing"
              v-on:dragging="draggingEv"
              v-on:resizing="resizingEv"
              v-on:resizeStop="resizestopEv"
              v-on:dragStop="dragstopEv"
              v-on:activated="activeEv"
              v-on:deactivated="deactive"
              v-on:delElement="delElementEv"
              @refLineParams="getRefLineParams($event, Number(directions[2]))"
              @click.stop.prevent
              @mouseup.stop.prevent
              @mousedown.stop.prevent
              :myId="{
                ...myid,
                elementInLayoutId: elementOption.elementInLayoutId,
                directionIndex: Number(directions[2])
              }"
            >
              <component
                v-if="elementOption.isShow"
                class="rect"
                :options="elementOption.options"
                :myid="{
                  ...myid,
                  elementInLayoutId: elementOption.elementInLayoutId,
                  directionIndex: Number(directions[2])
                }"
                :is="elementOption.innerElement"
              >
              </component>
            </vueDragResizable>
            <template v-for="(lineOption, index6) in lineList">
              <span
                class="ref-line v-line"
                v-for="item in lineOption.vLine"
                :key="'vLine' + item.id + index6"
                v-show="item.display && Number(directions[2]) == index6"
                :style="{
                  left: item.position,
                  top: item.origin,
                  height: item.lineLength
                }"
              />
              <span
                class="ref-line h-line"
                v-for="item in lineOption.hLine"
                :key="'hLine' + item.id + index6"
                v-show="item.display && Number(directions[2]) == index6"
                :style="{
                  top: item.position,
                  left: item.origin,
                  width: item.lineLength
                }"
              />
            </template>
            <div
              class="custom-handle"
              :class="['custom-handle-' + options.titleOptions[2].type, resizingTitleIndex === 2 ? 'show' : '']"
              draggable="true"
              @mousedown.stop="
                $myDrag(
                  {
                    ctx: _self,
                    dragStart: e => changeHeightMouseDownEv(e, 2),
                    dragging: e => changeHeightDarg(e, 2, options.titleOptions[2].type),
                    dragEnd: e => changeHeightMouseUpEv(e, 2, options.titleOptions[2].type, true)
                  },
                  $event
                )
              "
              :style="getHandleStyle(options.titleOptions[2])"
            >
              <span v-if="resizingTitleIndex === 2" class="size-popover">{{
                "W: " + options.titleOptions[2].width
              }}</span>
            </div>
          </div>
        </el-drawer>
      </div>
      <div
        @drop="handleColsDragover($event, 2)"
        @dragover.stop.prevent="dragoverEv($event, 2)"
        @dragleave.prevent="dragoverLeaveEv($event, 2)"
        @click="titleClick(directions[2])"
        class="other_content"
        v-show="isDrawerModeL === false && options.titleOptions[2].isShow"
        :style="{ width: options.titleOptions[2].width + 'px' }"
        :class="[options.titleOptions[2].type, isDragover !== 2 ? '' : 'isDrag-over']"
        @mouseenter.stop="otherMouseEnter"
        @mouseleave.stop="otherMouseLeave"
      >
        <vueDragResizable
          v-for="(elementOption, index) in options.titleOptions[2].elementOptions"
          v-show="elementOption.isShow"
          :key="'layoutComponent' + index"
          :class="[
            elementOption.isActive ? 'active' : '',
            `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_2-elementInLayoutId_${elementOption.elementInLayoutId}`
          ]"
          :data-innerElement="'element is:' + elementOption.innerElement"
          :parentW="options.titleOptions[2].width"
          :parentH="getParentH"
          :w="Number(elementOption.options.width)"
          :h="Number(elementOption.options.height)"
          :x="Number(elementOption.options.left)"
          :y="Number(elementOption.options.top)"
          :isLayoutTitle="true"
          :parent="true"
          :zoom="zoom"
          :direction="Number(directions[2])"
          :elementInLayoutId="elementOption.elementInLayoutId"
          :elementName="elementOption.innerElement"
          :active="elementOption.isActive"
          :options="elementOption.options"
          :rectId="myid.rect_id"
          :shape="elementOption.innerElement"
          :draggable="elementOption.draggable && !isResizing"
          v-on:dragging="draggingEv"
          v-on:resizing="resizingEv"
          v-on:resizeStop="resizestopEv"
          v-on:dragStop="dragstopEv"
          v-on:activated="activeEv"
          v-on:deactivated="deactive"
          v-on:delElement="delElementEv"
          @refLineParams="getRefLineParams($event, Number(directions[2]))"
          @click.stop.prevent
          @mouseup.stop.prevent
          @mousedown.stop.prevent
          :myId="{
            ...myid,
            elementInLayoutId: elementOption.elementInLayoutId,
            directionIndex: Number(directions[2])
          }"
        >
          <component
            v-if="elementOption.isShow"
            class="rect"
            :options="elementOption.options"
            :myid="{
              ...myid,
              elementInLayoutId: elementOption.elementInLayoutId,
              directionIndex: Number(directions[2])
            }"
            :is="elementOption.innerElement"
          >
          </component>
        </vueDragResizable>
        <template v-for="(lineOption, index6) in lineList">
          <span
            class="ref-line v-line"
            v-for="item in lineOption.vLine"
            :key="'vLine' + item.id + index6"
            v-show="item.display && Number(directions[2]) == index6"
            :style="{
              left: item.position,
              top: item.origin,
              height: item.lineLength
            }"
          />
          <span
            class="ref-line h-line"
            v-for="item in lineOption.hLine"
            :key="'hLine' + item.id + index6"
            v-show="item.display && Number(directions[2]) == index6"
            :style="{
              top: item.position,
              left: item.origin,
              width: item.lineLength
            }"
          />
        </template>
        <div
          class="custom-handle"
          :class="['custom-handle-' + options.titleOptions[2].type, resizingTitleIndex === 2 ? 'show' : '']"
          draggable="true"
          @mousedown.stop="
            $myDrag(
              {
                ctx: _self,
                dragStart: e => changeHeightMouseDownEv(e, 2),
                dragging: e => changeHeightDarg(e, 2, options.titleOptions[2].type),
                dragEnd: e => changeHeightMouseUpEv(e, 2, options.titleOptions[2].type, true)
              },
              $event
            )
          "
          :style="getHandleStyle(options.titleOptions[2])"
        >
          <span v-if="resizingTitleIndex === 2" class="size-popover">{{ "W: " + options.titleOptions[2].width }}</span>
        </div>
      </div>
      <div
        class="content_center scroller"
        :style="getScrollStyle"
        v-if="!options.turnOnScroll || emptyData || preventScroll"
      >
        <cx-row
          v-if="!emptyData"
          :zoom="zoom"
          :rowsOptions="options.rows[useActiveIndex]"
          :options="options"
          :myid="myid"
          :style="getWidth"
        />
        <!-- 空数据 -->
        <div class="null-data" v-else>
          <template v-if="options.emptyDataShowLocal">
            <div class="empty-img-bg" :style="emptyImgStyleObject"></div>
            <p :style="emptyTxtStyleObject">{{options.emptyContent}}</p>
          </template>
          <template v-else>
            <img src="../../../assets/images/img-null-data-light.png" alt="" />
            <p v-if="errorCode" class="textColor">{{ errorCode }}报错</p>
            <p v-else>暂无数据</p>
          </template>
        </div>
      </div>
      <div class="content_center1" v-else>
        <div ref="realBox" class="realBox" :style="getScrollStyle1" @mouseenter="enter" @mouseleave="leave">
          <div ref="slotList" class="content_center_div">
            <cx-row
              :zoom="zoom"
              :rowsOptions="options.rows[useActiveIndex]"
              :options="options"
              :myid="myid"
              :style="getWidth"
            />
          </div>
          <div v-html="copyHtml" class="content_center_div1"></div>
        </div>
      </div>
      <div v-show="options.titleOptions[3].isShow && isDrawerModeR">
        <el-drawer
          v-if="showDrawer"
          @dragover.stop.prevent="dragoverEv($event, 3)"
          @dragleave.prevent="dragoverLeaveEv($event, 3)"
          @drop.native="handleColsDragover($event, 3)"
          @click.native="titleClick(directions[3])"
          :size="options.titleOptions[3].width"
          :visible.sync="drawerR"
          :append-to-body="inBodyR"
          :with-header="false"
          :modal-append-to-body="inBodyR"
          :class="[isDragover !== 3 ? '' : 'isDrag-over']"
        >
          <div
            class="other_content"
            :style="{ width: options.titleOptions[3].width + 'px' }"
            :class="options.titleOptions[3].type"
            @mouseenter.stop="otherMouseEnter"
            @mouseleave.stop="otherMouseLeave"
          >
            <vueDragResizable
              v-for="(elementOption, index) in options.titleOptions[3].elementOptions"
              v-show="elementOption.isShow"
              :key="'layoutComponent' + index"
              :class="[
                elementOption.isActive ? 'active' : '',
                `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_3-elementInLayoutId_${elementOption.elementInLayoutId}`
              ]"
              :data-innerElement="'element is:' + elementOption.innerElement"
              :parentW="options.titleOptions[3].width"
              :parentH="getParentH"
              :w="Number(elementOption.options.width)"
              :h="Number(elementOption.options.height)"
              :x="Number(elementOption.options.left)"
              :y="Number(elementOption.options.top)"
              :isLayoutTitle="true"
              :parent="true"
              :zoom="zoom"
              :direction="Number(directions[3])"
              :elementInLayoutId="elementOption.elementInLayoutId"
              :elementName="elementOption.innerElement"
              :active="elementOption.isActive"
              :options="elementOption.options"
              :rectId="myid.rect_id"
              :shape="elementOption.innerElement"
              :draggable="elementOption.draggable && !isResizing"
              v-on:dragging="draggingEv"
              v-on:resizing="resizingEv"
              v-on:resizeStop="resizestopEv"
              v-on:dragStop="dragstopEv"
              v-on:activated="activeEv"
              v-on:deactivated="deactive"
              v-on:delElement="delElementEv"
              @refLineParams="getRefLineParams($event, Number(directions[3]))"
              @click.stop.prevent
              @mouseup.stop.prevent
              @mousedown.stop.prevent
              :myId="{
                ...myid,
                elementInLayoutId: elementOption.elementInLayoutId,
                directionIndex: Number(directions[3])
              }"
            >
              <component
                v-if="elementOption.isShow"
                class="rect"
                :options="elementOption.options"
                :myid="{
                  ...myid,
                  elementInLayoutId: elementOption.elementInLayoutId,
                  directionIndex: Number(directions[3])
                }"
                :is="elementOption.innerElement"
              >
              </component>
            </vueDragResizable>
            <!--辅助线-->
            <template v-for="(lineOption, index6) in lineList">
              <span
                class="ref-line v-line"
                v-for="item in lineOption.vLine"
                :key="'vLine' + item.id + index6"
                v-show="item.display && Number(directions[3]) == index6"
                :style="{
                  left: item.position,
                  top: item.origin,
                  height: item.lineLength
                }"
              />
              <span
                class="ref-line h-line"
                v-for="item in lineOption.hLine"
                :key="'hLine' + item.id + index6"
                v-show="item.display && Number(directions[3]) == index6"
                :style="{
                  top: item.position,
                  left: item.origin,
                  width: item.lineLength
                }"
              />
            </template>
            <!--辅助线END-->
            <!--拖拽线-->
            <div
              class="custom-handle"
              :class="['custom-handle-' + options.titleOptions[3].type, resizingTitleIndex === 3 ? 'show' : '']"
              draggable="true"
              @mousedown.stop="
                $myDrag(
                  {
                    ctx: _self,
                    dragStart: e => changeHeightMouseDownEv(e, 3),
                    dragging: e => changeHeightDarg(e, 3, options.titleOptions[3].type),
                    dragEnd: e => changeHeightMouseUpEv(e, 3, options.titleOptions[3].type, true)
                  },
                  $event
                )
              "
              :style="getHandleStyle(options.titleOptions[3])"
            >
              <span v-if="resizingTitleIndex === 3" class="size-popover">{{
                "W: " + options.titleOptions[3].width
              }}</span>
            </div>
          </div>
        </el-drawer>
      </div>
      <div
        @drop="handleColsDragover($event, 3)"
        @dragover.stop.prevent="dragoverEv($event, 3)"
        @dragleave.prevent="dragoverLeaveEv($event, 3)"
        @click="titleClick(directions[3])"
        class="other_content"
        v-show="options.titleOptions[3].isShow && isDrawerModeR === false"
        :style="{ width: options.titleOptions[3].width + 'px' }"
        :class="[options.titleOptions[3].type, isDragover !== 3 ? '' : 'isDrag-over']"
        @mouseenter.stop="otherMouseEnter"
        @mouseleave.stop="otherMouseLeave"
      >
        <vueDragResizable
          v-for="(elementOption, index) in options.titleOptions[3].elementOptions"
          v-show="elementOption.isShow"
          :key="'layoutComponent' + index"
          :class="[
            elementOption.isActive ? 'active' : '',
            `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_3-elementInLayoutId_${elementOption.elementInLayoutId}`
          ]"
          :data-innerElement="'element is:' + elementOption.innerElement"
          :parentW="options.titleOptions[3].width"
          :parentH="getParentH"
          :w="Number(elementOption.options.width)"
          :h="Number(elementOption.options.height)"
          :x="Number(elementOption.options.left)"
          :y="Number(elementOption.options.top)"
          :isLayoutTitle="true"
          :parent="true"
          :zoom="zoom"
          :direction="Number(directions[3])"
          :elementInLayoutId="elementOption.elementInLayoutId"
          :elementName="elementOption.innerElement"
          :active="elementOption.isActive"
          :options="elementOption.options"
          :rectId="myid.rect_id"
          :shape="elementOption.innerElement"
          :draggable="elementOption.draggable && !isResizing"
          v-on:dragging="draggingEv"
          v-on:resizing="resizingEv"
          v-on:resizeStop="resizestopEv"
          v-on:dragStop="dragstopEv"
          v-on:activated="activeEv"
          v-on:deactivated="deactive"
          v-on:delElement="delElementEv"
          @refLineParams="getRefLineParams($event, Number(directions[3]))"
          @click.stop.prevent
          @mouseup.stop.prevent
          @mousedown.stop.prevent
          :myId="{
            ...myid,
            elementInLayoutId: elementOption.elementInLayoutId,
            directionIndex: Number(directions[3])
          }"
        >
          <component
            v-if="elementOption.isShow"
            class="rect"
            :options="elementOption.options"
            :myid="{
              ...myid,
              elementInLayoutId: elementOption.elementInLayoutId,
              directionIndex: Number(directions[3])
            }"
            :is="elementOption.innerElement"
          >
          </component>
        </vueDragResizable>
        <!--辅助线-->
        <template v-for="(lineOption, index6) in lineList">
          <span
            class="ref-line v-line"
            v-for="item in lineOption.vLine"
            :key="'vLine' + item.id + index6"
            v-show="item.display && Number(directions[3]) == index6"
            :style="{
              left: item.position,
              top: item.origin,
              height: item.lineLength
            }"
          />
          <span
            class="ref-line h-line"
            v-for="item in lineOption.hLine"
            :key="'hLine' + item.id + index6"
            v-show="item.display && Number(directions[3]) == index6"
            :style="{
              top: item.position,
              left: item.origin,
              width: item.lineLength
            }"
          />
        </template>
        <!--辅助线END-->
        <!--拖拽线-->
        <div
          class="custom-handle"
          :class="['custom-handle-' + options.titleOptions[3].type, resizingTitleIndex === 3 ? 'show' : '']"
          draggable="true"
          @mousedown.stop="
            $myDrag(
              {
                ctx: _self,
                dragStart: e => changeHeightMouseDownEv(e, 3),
                dragging: e => changeHeightDarg(e, 3, options.titleOptions[3].type),
                dragEnd: e => changeHeightMouseUpEv(e, 3, options.titleOptions[3].type, true)
              },
              $event
            )
          "
          :style="getHandleStyle(options.titleOptions[3])"
        >
          <span v-if="resizingTitleIndex === 3" class="size-popover">{{ "W: " + options.titleOptions[3].width }}</span>
        </div>
      </div>
    </div>
    <div
      @drop="handleColsDragover($event, 1)"
      @dragover.stop.prevent="dragoverEv($event, 1)"
      @dragleave.prevent="dragoverLeaveEv($event, 1)"
      @click="titleClick(directions[1])"
      class="other_content"
      v-show="options.titleOptions[1].isShow"
      :style="{ height: options.titleOptions[1].height + 'px' }"
      :class="[options.titleOptions[1].type, isDragover !== 1 ? '' : 'isDrag-over']"
      @mouseenter.stop="otherMouseEnter"
      @mouseleave.stop="otherMouseLeave"
    >
      <vueDragResizable
        v-for="(elementOption, index) in options.titleOptions[1].elementOptions"
        v-show="elementOption.isShow"
        :class="[
          elementOption.isActive ? 'active' : '',
          `container_id_${myid.container_id}-rect_id_${myid.rect_id}-directionIndex_1-elementInLayoutId_${elementOption.elementInLayoutId}`
        ]"
        :key="'layoutComponent' + index"
        :data-innerElement="'element is:' + elementOption.innerElement"
        :parentW="getParentW"
        :parentH="options.titleOptions[1].height"
        :w="elementOption.options ? Number(elementOption.options.width) : 0"
        :h="elementOption.options ? Number(elementOption.options.height) : 0"
        :x="elementOption.options ? Number(elementOption.options.left) : 0"
        :y="elementOption.options ? Number(elementOption.options.top) : 0"
        :isLayoutTitle="true"
        :parent="true"
        :zoom="zoom"
        :direction="Number(directions[1])"
        :elementInLayoutId="elementOption.elementInLayoutId"
        :elementName="elementOption.innerElement"
        :active="elementOption.isActive"
        :options="elementOption.options"
        :rectId="myid.rect_id"
        :shape="elementOption.innerElement"
        :draggable="elementOption.draggable && !isResizing"
        v-on:dragging="draggingEv"
        v-on:resizing="resizingEv"
        v-on:resizeStop="resizestopEv"
        v-on:dragStop="dragstopEv"
        v-on:activated="activeEv"
        v-on:deactivated="deactive"
        v-on:delElement="delElementEv"
        @refLineParams="getRefLineParams($event, Number(directions[1]))"
        @click.stop.prevent
        @mouseup.stop.prevent
        @mousedown.stop.prevent
        :myId="{ ...myid, elementInLayoutId: elementOption.elementInLayoutId, directionIndex: Number(directions[1]) }"
      >
        <component
          v-if="elementOption.isShow"
          class="rect"
          :options="elementOption.options"
          :myid="{ ...myid, elementInLayoutId: elementOption.elementInLayoutId, directionIndex: Number(directions[1]) }"
          :is="elementOption.innerElement"
        >
        </component>
      </vueDragResizable>
      <!--辅助线-->
      <template v-for="(lineOption, index6) in lineList">
        <span
          class="ref-line v-line"
          v-for="item in lineOption.vLine"
          :key="'vLine' + item.id + index6"
          v-show="item.display && Number(directions[1]) == index6"
          :style="{
            left: item.position,
            top: item.origin,
            height: item.lineLength
          }"
        />
        <span
          class="ref-line h-line"
          v-for="item in lineOption.hLine"
          :key="'hLine' + item.id + index6"
          v-show="item.display && Number(directions[1]) == index6"
          :style="{
            top: item.position,
            left: item.origin,
            width: item.lineLength
          }"
        />
      </template>
      <!--辅助线END-->
      <!--拖拽线-->
      <div
        class="custom-handle"
        :class="['custom-handle-' + options.titleOptions[1].type, resizingTitleIndex === 1 ? 'show' : '']"
        draggable="true"
        @mousedown.stop="
          $myDrag(
            {
              ctx: _self,
              dragStart: e => changeHeightMouseDownEv(e, 1),
              dragging: e => changeHeightDarg(e, 1, options.titleOptions[1].type),
              dragEnd: e => changeHeightMouseUpEv(e, 1, options.titleOptions[1].type, true)
            },
            $event
          )
        "
        :style="getHandleStyle(options.titleOptions[1])"
      >
        <span v-if="resizingTitleIndex === 1" class="size-popover">{{ "H: " + options.titleOptions[1].height }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { materialLoader } from "core/materialLoader"
import { getAppointCacheData } from "utils/updateData/publicDataUtils/getRestClassify.js"
import { UpdateLayoutData } from "utils/updateData/layout/layoutComponentUpdateData.js"
import { updateSubPageMapping } from "utils/updateData/publicDataUtils/subPageUpdateData.js"
import cxSwitch from "components/elementComponents/switch/index.vue"
import vueDragResizable from "components/publicComponent/vueDragRiseable/vue-drag-resizable.vue"
import eventMixin from "utils/event/eventMixin.js"
import { text_children } from "materials/text/menus/index.js"
import defaultImgEmpty from "assets/images/img-null-data-light.png"
import subPageEventMixin from "utils/event/subPageEventMixin.js"
import {
  findTabs,
  findAllComponentsInTitleOptions,
  replaceUrlParam,
  _throttle,
  _debounce,
  deepChangeUid,
  getHtmlPlainText,
  getAllColsUidInLayoutComponent,
  findHistoryLayoutType,
  checkIrregularLayout,
  recordOldSize,
  isExist
} from "../../../utils"
import { getSyetemModuleJson } from "@/utils/initEv.js"
import plugins from "./plugin"
import { CATEGORY_MODE } from "@/consts/index"

export default {
  mixins: [eventMixin, plugins, subPageEventMixin],
  name: "layoutComponent",
  components: {
    ...materialLoader.getRenderComponentsMixin([
      "cxButton",
      "cxText",
      "cxLabel",
      "cxNavMenuVertical",
      "cxNavMenu",
      "cxTabs",
      "cxPagination",
      "cxBreadCrumbs",
      "imageComponent",
      "cxIcon",
      "cxHomeLine",
      "cxVerticalLine",
      "cxEditor",
      "cxAudio",
      "cxMultiFilter",
      "cxDigitRoll",
      "cxAutoLayout",
      "cxAnchorComponent",
      "cxSort",
      "cxShare",
      "cxCountdown"
    ]),
    cxSwitch,
    vueDragResizable
  },
  data() {
    this.isMounted = false
    return {
      isResizing: false,
      isDragover: undefined,
      showDrawer: false,
      showLayout: true,
      getParentW: null,
      getParentH: null,
      textOptions: {
        type: Array,
        default: []
      },
      activeTabId: "",
      lineList: [
        {
          vLine: [],
          hLine: []
        },
        {
          vLine: [],
          hLine: []
        },
        {
          vLine: [],
          hLine: []
        },
        {
          vLine: [],
          hLine: []
        }
      ],
      appId: null,
      pageId: null,
      restDataUrl: null,
      typeVal: null,
      websiteId: null,
      wfwfid: null,
      colsIdFromActiveRect: [],
      cacheDataTypes: [],
      restUrl: null,
      initOtherContentH: null,
      initOtherContentW: null,
      isInitPaginationCurrentPageFlag: false, // 是否需要初始化分页组件的当前页，一般指切换分类时，将当前页设为1
      directions: [0, 1, 2, 3],
      subPage: null,
      listPageTypeId: null,
      typeIdsArr: [],
      relIdsArr: [],
      isOrBool: false,
      groupTypeId: "",
      dateValStr: "",
      searchValue: "",
      isSsrPage: false,
      searchKey: null, // 如果当前在搜索列表页中，需要传递搜索关键字
      isGroupSearch: false, // 是否是聚合搜索
      isGroupSearchInit: false, // 是否初始化聚合搜索
      groupSearchInitKeys: [], // 聚合搜索初始化的关键字集合
      groupSearchEngineInstanceId: null, // 聚合搜索的引擎实例id
      updatePageSize: true,
      paginationDirectionIndex: null, // 分页组件所在方向
      paginationElementInLayoutId: null, // 分页组件所在elementInLayoutId
      activeIndex: 0,
      delay: 0,
      copyHtml: "",
      realBoxBase: 0, // 每个单元格内容实际高度或宽度
      direction: 1, // 0 往下 1 往上
      reloadTimer: null,
      resizingTitle: false,
      resizingTitleIndex: null,
      directionIndexOther: null,
      defaultImgEmpty: defaultImgEmpty,
    }
  },
  props: {
    parentOptions: {
      type: Object
    },
    options: {
      type: Object,
      default: null
    },
    zoom: {
      type: Number,
      default: 1
    },
    myid: {
      type: Object,
      default: null
    }
  },
  watch: {
    "options.width"(o, n) {
      const style = window.getComputedStyle(this.$el.parentNode, null)
      this.getParentH = parseInt(style.getPropertyValue("height"), 10) - this.getOtherContentLRHeight()
      this.getParentW = parseInt(style.getPropertyValue("width"), 10)
    },
    "options.height"(o, n) {
      const style = window.getComputedStyle(this.$el.parentNode, null)
      this.getParentH = parseInt(style.getPropertyValue("height"), 10) - this.getOtherContentLRHeight()
      this.getParentW = parseInt(style.getPropertyValue("width"), 10)
    },
    "options.activeIndex"(o, n) {
      if (this.options.noCacheComponent) {
        this.isInitPaginationCurrentPageFlag = true
        if (this.renderModel === 'type') {
          this.asyncUpdateComponent(JSON.parse(JSON.stringify(this.options)))
        } else {
          this.getUpdateData("activeIndex")
        }
        this.updatePageSize = false
      }
    },
    "options.name": {
      handler: function (newVal, oldVal) {
        if (this.options.noCacheComponent) {
          console.log(">>>>", newVal, oldVal)
          const { wfwfid } = this.$store.state.states.getDataPageIds
          let subPages = this.$store.state[this.request_prefix].page?.subPages
          if(!subPages){
            return
          }
          let temp = JSON.parse(JSON.stringify(subPages))
          const index = temp.findIndex(item => item.appId === this.options.appId)
          if (index === -1 || index === undefined) return
          const { detailPageId, listPageId } = temp[index]
          if (detailPageId) {
            temp[index].detailPageSetting.name = newVal
          }
          if (listPageId) {
            temp[index].listPageSetting.name = newVal
          }
          updateSubPageMapping.call(this, temp)
        }
      }
    },
    "options.encId": {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.reload()
        }
      }
    },
    "options.openHideEmptyCell"(o, n) {
      if (this.options.noCacheComponent) {
        this.isInitPaginationCurrentPageFlag = true
        this.getUpdateData("activeIndex")
      }
    },
    currentPageNum(n, o) {
      if (o !== n && typeof n !== "undefined") {
        console.log("currentPageNum")
        this.getUpdateData("pagination")
      }
    },
    currentNavMenuValue(o, n) {
      if (this.options.noCacheComponent && o !== n) {
        this.isInitPaginationCurrentPageFlag = true
        console.log("navMenu")
        this.getUpdateData("navMenu")
      }
    },
    ids: {
      deep: true,
      handler: function (n, o) {
        if (n.container_id !== this.myid.container_id || n.rect_id !== this.myid.rect_id) {
          this.clearTitleOptActive()
        }
        if (
          this.options.activeCol !== "" &&
          (n.container_id !== this.myid.container_id || n.rect_id !== this.myid.rect_id || n.uid === null)
        ) {
          //如果当前选中的id与当前的col的id不一致，则清除当前col的选中态，以及col内的组件的选中态
          this.$changeOptionsEV(
            "",
            "activeCol",
            false,
            null,
            {
              container_id: this.myid.container_id,
              rect_id: this.myid.rect_id
            },
            true
          )
        }
      }
    },
    // 修改行列和切换样式的时候格子数会改变
    pageSize: {
      handler(newVal, oldVal) {
        console.log("pageSize :>>", newVal, oldVal)
        const { engineInstanceId, engineInstanceAppId } = this.options
        // updatePageSize 切换tab的时候不要调用
        if (
          this.updatePageSize &&
          oldVal !== undefined &&
          newVal !== oldVal &&
          (engineInstanceId || engineInstanceAppId)
        ) {
          let pageSizeList = sessionStorage.getItem("pageSizeList") || "[]"
          pageSizeList = pageSizeList && JSON.parse(pageSizeList)
          const params = {
            appId: engineInstanceAppId,
            e: engineInstanceId,
            p2: newVal,
            a: this.request_prefix === "appStage" ? 1 : 0
          }
          let index = pageSizeList.findIndex(item => item.appId === engineInstanceAppId)
          if (index === -1) pageSizeList.push(params)
          else pageSizeList.splice(index, 1, params)
          console.log("pageSizeList :>>", pageSizeList)
          sessionStorage.setItem("pageSizeList", JSON.stringify(pageSizeList))
        }
      }
    },
    "options.turnOnScroll": {
      handler(n, o) {
        if (n) {
          this.asyncUpdateComponent(JSON.parse(JSON.stringify(this.options)))
          if (!this.options.noCacheComponent) {
            this.reset()
          }
        } else if (n === false) {
          //停止滚动
          this._stopMove()
          //  恢复旧的数据
          this.asyncUpdateComponent(JSON.parse(JSON.stringify(this.options)))
          this.xPos = 0
          this.yPos = 0
          this.realBoxBase = 0
        }
      }
    },
    "options.scrollReload": {
      handler(n, o) {
        if (n) {
          this._stopMove()
          this.asyncUpdateComponent(JSON.parse(JSON.stringify(this.options)))
          this.xPos = 0
          this.yPos = 0
          this.realBoxBase = 0
          this.$changeOptionsEV(false, "scrollReload", false, null, this.myid)
        }
      }
    },
    "options.hoverStopScroll": function () {
      this.reset()
    },
    "options.scrollSpeed": function () {
      if (this.options.turnOnScroll) {
        this.reset()
      }
    },
    "options.waitTime": function () {
      if (this.options.turnOnScroll) {
        this.reset()
      }
    },
    showClassification() {
      this.renderModel === 'type' && this.asyncUpdateComponent(JSON.parse(JSON.stringify(this.options)))
    }
  },
  computed: {
    showClassification() {
      return this.options?.titleOptions?.some(item => {
        return item.elementOptions?.find(item => {
          return item.type === "classification" && item.isShow
        })
      })
    },
    renderModel() {
      return this.options?.pluginName?.includes('renderTypeCol') ? 'type' : 'data'
    },
    useActiveIndex() {
      return this.categoryMode === CATEGORY_MODE.SAME && !this.showComponentBoxSetting ? 0 : this.options.activeIndex
    },
    showComponentBoxSetting() {
      // 特殊组件不走同步规则
      const hideNames = ["searchComponentPlugin", "loginLayoutComponent", "loginEngineComponentPlugin", "appNavPlugin", "ListPageSearchComponentPlugin"]
      if (this?.options?.pluginName?.length) {
        return this?.options?.pluginName?.length
          ? this.options.pluginName.find(it => {
              return hideNames.find(_it => _it === it)
            })
          : false
      } else if (this?.options?.name === "超星头像" || this?.options?.menuName === "列表页搜索") {
        return true
      }
    },
    pageSize() {
      if (this.options) {
        let colsIdFromActiveRect = getAllColsUidInLayoutComponent([this.options.rows[this.useActiveIndex]])
        return colsIdFromActiveRect && colsIdFromActiveRect.length
      }
    },
    emptyData() {
      // 没有设置过的样式没有openHideEmptyCell
      if (this.options.hasOwnProperty("openHideEmptyCell"))
        return this.options.openHideEmptyCell && this.options.emptyData
      else return this.options.emptyData
    },
    errorCode() {
      return this.options.errorCode
    },
    ids() {
      return this.$store.state.states.activeID
    },
    parentW() {
      return 100
    },
    getHandleStyle() {
      return function (item) {
        // if (item.elementOptions.length > 0 && this.judgeIsShow(item.elementOptions)) {
        let style = {}
        switch (item.type) {
          case "top":
            style = {
              bottom: 0,
              height: "1px",
              width: "100%",
              cursor: "ns-resize"
            }
            break
          case "bottom":
            style = {
              top: 0,
              height: "1px",
              width: "100%",
              cursor: "ns-resize"
            }
            break
          case "left":
            style = {
              right: 0,
              width: "1px",
              height: "100%",
              cursor: "ew-resize"
            }
            break
          case "right":
            style = {
              left: 0,
              width: "1px",
              height: "100%",
              cursor: "ew-resize"
            }
            break
          default:
        }
        return style
      }
    },
    getContentHeight() {
      let emptyLayoutComponentTitleH = 0
      // 针对自由布局做特殊处理，减去左右的宽度
      this.options.titleOptions.forEach(item => {
        if (item.type === "top" || item.type === "bottom") {
          if (item.isShow) emptyLayoutComponentTitleH += item.height
        }
      })
      return {
        height: `calc(100% - ${emptyLayoutComponentTitleH}px)`
      }
    },
    getOtherContentStyle() {
      return function (item) {
        let lrHeight = 0
        if (item.isShow) {
          if (item.type === "top" || item.type === "bottom") {
            return {
              height: item.height + "px",
              width: "100%"
            }
          } else if (item.type === "left" || item.type === "right") {
            // 需要判断'top'和'bottom'的内容是否显示，如果有的话，需要减去上下高度之和
            let lrHeight = 0
            for (let i = 0; i < this.options.titleOptions.length; i++) {
              const titleOptionItem = this.options.titleOptions[i]
              if (titleOptionItem.elementOptions.length === 0) continue
              if (titleOptionItem.type === "top" || titleOptionItem.type === "bottom") {
                for (let j = 0; j < titleOptionItem.elementOptions.length; j++) {
                  if (titleOptionItem.elementOptions[j].isShow) {
                    lrHeight += this.options.titleOptionsHeight
                    break
                  }
                }
              }
            }
            return {
              width: this.options.titleOptionsWidth + "px",
              height: `calc(100% - ${lrHeight}px)`
            }
          } else {
            return
          }
        }
      }
    },
    containerRowStyle() {
      let emptyLayoutComponentTitleW,
        emptyLayoutComponentTitleH = 0
      // 针对自由布局做特殊处理，减去左右的宽度
      this.options.titleOptions.forEach(item => {
        if (item.type === "top" || item.type === "bottom") {
          if (item.isShow) emptyLayoutComponentTitleH += item.height
        }
        if (item.type === "left" || item.type === "right") {
          if (item.isShow) emptyLayoutComponentTitleW += item.width
        }
      })
      return {
        height: this.options.height - emptyLayoutComponentTitleH + "px",
        width: this.options.width - emptyLayoutComponentTitleW + "px"
      }
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let background
      if (!this.options.background || !Array.isArray(this.options.background)) {
        background = [
          {
            type: "img",
            imgUrl: this.options.imgSrc,
            clipSize: this.options.clipSize,
            repeatType: this.options.repeatType,
            alignType: this.options.alignType
          }
        ]
      } else {
        background = this.options.background
      }
      background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            if (bg.imgUrl) {
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
            }
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            // containerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            containerBg.backgroundColor = this.$parseColor(bg)
            containerBg.backgroundImage = this.setBorderColor(containerBg.backgroundColor,containerBg.backgroundImage)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              // containerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundImage = this.setBorderColor("",containerBg.backgroundImage)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      if (this.options.showBorder !== false && this.isGradientBorder(this.options.borderColor, this.options.borderIsThemeColor)) {
        containerBg.backgroundClip = "padding-box,border-box"// 圆角裁切
        containerBg.backgroundOrigin = "padding-box,border-box"
      }
      return containerBg
    },
    containerStyle() {
      let borderW = "",
        padding,
        boxShadowStyle = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      if (this.options.topNavPaddingTypeFlag == 1) {
        padding = this.options.padding + "px"
      } else {
        padding = `${this.options.paddingTop}px  ${this.options.paddingRight}px  ${this.options.paddingBottom}px  ${this.options.paddingLeft}px`
      }
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            boxShadowStyle += ","
          }
          boxShadowStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.$parseColor(this.options.boxShadowColor[index])}`
        })
      } else {
        boxShadowStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return {
        ...this.bgStyle,
        padding: padding,
        "border-style": this.options.borderStyle || "solid",
        // "border-color": this.options.borderIsThemeColor
        //   ? this.$store.state[this.request_prefix].page.themeColor
        //   : this.options.borderColor.color
        //   ? this.options.borderColor.color
        //   : this.options.borderColor,
        "border-color": this.isGradientBorder(this.options.borderColor, this.options.borderIsThemeColor) ? "transparent" : this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": this.options.showBorder !== false ? borderW : 0,
        "box-shadow": boxShadowStyle,
        "border-top-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopLeftRadius + "px",
        "border-top-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomRightRadius + "px",
        opacity: this.options.opacity / 100
      }
    },
    styleObject() {
      let boxShadowStyle = ""
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            boxShadowStyle += ","
          }
          boxShadowStyle += `${this.options.boxShadowH[index]}px ${this.options.boxShadowV[index]}px ${this.options.boxShadowBlur[index]}px ${this.options.boxShadowSpread[index]}px ${this.$parseColor(this.options.boxShadowColor[index])}`
        })
      } else {
        boxShadowStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return {
        "border-top-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopLeftRadius + "px",
        "border-top-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderTopRightRadius + "px",
        "border-bottom-left-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomLeftRadius + "px",
        "border-bottom-right-radius":
          this.options.shapeType == "round"
            ? this.options.borderTopLeftRadius
            : this.options.borderBottomRightRadius + "px",
        "border-style": this.options.borderStyle,
        // "border-color": this.options.borderColor,
        "border-color": this.isGradientBorder(this.options.borderColor, this.options.borderIsThemeColor) ? "transparent" : this.$parseColor(this.options.borderColor, {
          isThemeColor: this.options.borderIsThemeColor
        }),
        "border-width": this.options.borderWidth + "px",
        "box-shadow": boxShadowStyle,
        transform: "rotate(" + this.options.rotate + "deg)",
        "background-image": "url(" + this.options.imgSrc + ")",
        "background-repeat": this.options.repeatType,
        "background-size": this.options.clipSize,
        "background-position": this.options.alignType,
        opacity: this.options.opacity / 100,
        "--scale-hover": this.options.hoverZoomLevel
      }
    },
    currentPageNum() {
      for (let i = 0; i < this.options.titleOptions.length; i++) {
        if (this.options.titleOptions[i].elementOptions.length > 0) {
          const elementOptions = this.options.titleOptions[i].elementOptions
          for (let j = 0; j < elementOptions.length; j++) {
            if (elementOptions[j].type === "pagination" && elementOptions[j].isShow) {
              this.paginationDirectionIndex = i
              this.paginationElementInLayoutId = elementOptions[j].elementInLayoutId
              return elementOptions[j].options.value
            }
          }
        }
      }
    },
    currentNavMenuValue() {
      for (let i = 0; i < this.options.titleOptions.length; i++) {
        if (this.options.titleOptions[i].elementOptions.length > 0) {
          const elementOptions = this.options.titleOptions[i].elementOptions
          for (let j = 0; j < elementOptions.length; j++) {
            if (elementOptions[j].type === "navMenu" || elementOptions[j].type === "navMenuVertical") {
              return elementOptions[j].options.value
            }
          }
        }
      }
    },
    isDrawerModeL: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "isDrawerModeL", "isDrawerModeL", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "isDrawerModeL", false, null, this.myid)
      }
    },
    drawerL: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "drawerL", "drawerL", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerL", false, null, this.myid)
      }
    },
    categoryMode: {
      get() {
        return this.options.categoryMode
      }
    },
    inBodyL: {
      get() {
        this.isMounted && setImmediate(() => this.reloadDrawer())
        return this.checkAndSetPrimaryVal(this.options, "inBodyL", "inBodyL", true)
      },
      set(val) {
        this.$changeOptionsEV(val, "inBodyL", false, null, this.myid)
      }
    },
    inBodyR: {
      get() {
        this.isMounted && setImmediate(() => this.reloadDrawer())
        return this.checkAndSetPrimaryVal(this.options, "inBodyR", "inBodyR", true)
      },
      set(val) {
        this.$changeOptionsEV(val, "inBodyR", false, null, this.myid)
      }
    },
    isDrawerModeR: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "isDrawerModeR", "isDrawerModeR", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "isDrawerModeR", false, null, this.myid)
      }
    },
    drawerR: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "drawerR", "drawerR", false)
      },
      set(val) {
        this.$changeOptionsEV(val, "drawerR", false, null, this.myid)
      }
    },
    getScrollStyle() {
      if (this.myid.rect_id === this.ids.rect_id && this.ids.uid) {
        return
      } else if (this.options.showScorll === true) {
        return {
          "overflow-y": this.options.scorllType === "vertical" ? "auto" : "hidden",
          "overflow-x": this.options.scorllType === "vertical" ? "hidden" : "auto"
        }
      }
    },
    getScrollStyle1() {
      let base = 200
      if (this.options.noCacheComponent) {
        base = 200 * this.options.scrollMultiple
      }
      const style = {
        transition: `all ${this.ease} ${this.delay}ms`,
        flexDirection: this.layoutType === "col" ? "column" : "row"
      }
      this.layoutType === "col" ? (style.height = base + "%") : (style.width = base + "%")
      return style
    },
    getWidth() {
      return {
        width:
          this.options.showScorll === true && this.options.scorllType !== "vertical"
            ? this.options.contentWidth + "%"
            : "100%",
        height:
          this.options.showScorll === true && this.options.scorllType === "vertical"
            ? this.options.contentWidth + "%"
            : this.options.showScorll === true && this.options.scorllType !== "vertical"
            ? "calc(100% - 1px)"
            : "100%"
      }
    },
    realSingleStopHeight() {
      if (this.preventScroll) {
        return 0
      }
      const [layoutType] = this.layoutTypeAndOptions
      const { tabsList = [], oldRowsLength = {}, oldColsLength = {} } = this.options
      let index = 0
      if (tabsList.length > 0 && tabsList[0].name === "全部" && !tabsList[0].id) {
        index = tabsList.length > 1 ? 1 : 0
      }
      const tabId = tabsList.length === 0 ? this.useActiveIndex : (tabsList[index].id || 0)
      const rowsLength = oldRowsLength[tabId]
      const colsLength = oldColsLength[tabId]
      const base = layoutType === "col" ? 1 / rowsLength : 1 / colsLength
      const real =
        layoutType === "col"
          ? this.$refs.realBox.parentElement.offsetHeight
          : this.$refs.realBox.parentElement.offsetWidth
      return parseInt(real * base)
    },
    hoverStopSwitch() {
      return (this.options.hoverStopScroll && this.options.turnOnScroll && !this.emptyData) || false
    },
    layoutTypeAndOptions() {
      return findHistoryLayoutType(this.options.rows[this.useActiveIndex])
    },
    layoutType() {
      return this.layoutTypeAndOptions[0]
    },
    preventScroll() {
      const { rowLens, colLens } = checkIrregularLayout([this.options.rows[this.useActiveIndex]])
      return !(rowLens === 1 && colLens > 1) && !(rowLens > 1 && colLens === 1)
    },
    isClonePattern() {
      return this.$store.state.states.isClonePattern || this.$store.state.states.isOrderPattern
    },
    emptyImgStyleObject(){
      // 空状态图片样式
      let imgSrc = this.options.emptyImgSrc || this.defaultImgEmpty
      let width1 = this.options.emptyImgWidth || 144
      let height1 = this.options.emptyImgHeight || 104
      return {
        "width": width1 + "px",
        "height": height1 + "px",
        "background-image": "url(" + imgSrc + ")",
        "background-repeat": this.options.emptyImgRepeatType || "no-repeat",
        "background-size": this.options.emptyImgClipSize || "cover",
        "background-position": this.options.emptyImgAlignType || "left top",
        "background-clip": "content-box",
      }
    },
    emptyTxtStyleObject() {
      // 空状态文字样式
      return {
        "color": this.$parseColor(this.options.emptyFontColor),
        "font-Family": this.options.emptyFontFamily,
        "font-size": this.options.emptyFontSize + "px",
        "font-weight": this.options.emptyFontWeight,
      }
    },
    borderColorType() {
      return this.options?.borderColor?.type
    },
    setBorderColor() {
      return function (bgColor, backgroundImage) {
        const borderColor = this.options.borderColor
        if (borderColor.type === "color") return backgroundImage
        let gradientColor = ""

        switch (borderColor.type) {
          case "linearGradient":
            let tmp = []
            if (borderColor.data.stops && borderColor.data.stops.length > 0) {
              borderColor.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = gradientColor.length > 0 ? "," : ""
              // gradientColor += dot + "linear-gradient(" + borderColor.data.angle + "deg," + tmp.join(",") + ")"
              gradientColor += dot + this.$parseColor(borderColor)
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (borderColor.data.stops && borderColor.data.stops.length > 0) {
              borderColor.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = gradientColor.length > 0 ? "," : ""
              const siteX = borderColor.data.siteX ? borderColor.data.siteX : 0
              const siteY = borderColor.data.siteY ? borderColor.data.siteY : 0
              // gradientColor +=
              //   dot + "radial-gradient(at " + siteX + "% " + siteY + "%," + radialTmp.join(",") + ")"
              gradientColor += dot + this.$parseColor(borderColor)
            }
            break
          default:
        }
        if (backgroundImage) {
          return gradientColor ? backgroundImage + `,${gradientColor}` : backgroundImage
        } else if (bgColor) {
          return `linear-gradient(to bottom,${bgColor}, ${bgColor}),${gradientColor}`
        } else return backgroundImage
      }
    },
  },
  methods: {
    isGradientBorder(borderColor, themeColor) {
      let isThemeColor = false
      if (borderColor && borderColor.hasOwnProperty("isThemeColor")) isThemeColor = borderColor.isThemeColor
      else if (typeof borderColor === 'string') isThemeColor = themeColor
      return borderColor && borderColor.type !== "color" && !isThemeColor
    },
    clearDirtyRect(){
      let delRects = []
      this.options.titleOptions.forEach((title,index)=>{
        title.elementOptions.forEach(rect=>{
          if(rect.innerElement === 'emptyLayoutComponent'){
            // 删除
            delRects.push({
              ...this.myid,
              directionIndex:index,
              elementInLayoutId: rect.elementInLayoutId
            })
          }
        })
      })
      delRects.forEach(rectIds=>{
        this.$store.dispatch(this.request_prefix + "/deleteElement", rectIds)
      })
    },
    activeLayoutComponent() {},
    async reload() {
      return new Promise((resolve, reject) => {
        this.showLayout = false
        setImmediate(() => {
          this.showLayout = true
          resolve()
        })
      })
    },
    async reloadDrawer() {
      return new Promise((resolve, reject) => {
        this.showDrawer = false
        setImmediate(() => {
          this.showDrawer = true
          resolve()
        })
      })
    },
    resizingEv: _throttle(function (rect, elementInLayoutId, uid, direction) {
      this.isResizing = true
      if (!rect.isQuickSite) {
        this.changeVGR(rect, "left", elementInLayoutId, uid, direction)
        this.changeVGR(rect, "top", elementInLayoutId, uid, direction)
      }
      this.changeVGR(rect, "width", elementInLayoutId, uid, direction)
      this.changeVGR(rect, "height", elementInLayoutId, uid, direction)
    }, 100),
    clearTitleOptActive() {
      let delAllTitleActive = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path
      }
      //初次进来 先取消当前cols中的所有元素的active效果
      this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", delAllTitleActive)
    },
    layoutClick() {
      this.titleClick(this.directionIndexOther)
      this.directionIndexOther = undefined
    },
    titleClick(direction) {
      // 当前功能，边栏没有选中功能，所以点击边框激活自由布局，点击内边距也是调用此方法选中自由布局
      if (this.isBigScreenPreview()) return
      let oldIds = JSON.parse(JSON.stringify(this.ids))
      if (
        isExist(oldIds.elementInAutoLayoutId) &&
        oldIds.rect_id !== this.myid.rect_id &&
        oldIds.directionIndexOther !== direction
      ) {
        this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", oldIds)
      }
      const activeID = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        directionIndexOther: direction,
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path
      }
      this.directionIndexOther = direction
      this.$store.commit("states/changeActiveID", activeID)
      this.$store.commit("states/changeElementType", this.options.innerElement)
      this.clearTitleOptActive()
      // this.$store.dispatch(this.request_prefix + "/changeLayoutTitleActive", { ...this.ids })
    },
    draggingEv(rect) {},
    activated(elementInLayoutId, uid) {},
    dragstopEv(rect, elementInLayoutId, uid, direction) {
      this.changeVGR(rect, "left", elementInLayoutId, uid, direction)
      this.changeVGR(rect, "top", elementInLayoutId, uid, direction)
    },
    resizestopEv(rect, elementInLayoutId, uid, direction) {
      this.isResizing = false
      if (!rect.isQuickSite) {
        this.changeVGR(rect, "left", elementInLayoutId, uid, direction)
        this.changeVGR(rect, "top", elementInLayoutId, uid, direction)
      }
      this.changeVGR(rect, "width", elementInLayoutId, uid, direction)
      this.changeVGR(rect, "height", elementInLayoutId, uid, direction)
    },
    //封装的修改布局组件中的组件的大小和位置的函数
    changeVGR(rect, change, elementInLayoutId, uid, direction) {
      let param1 = {
        ...this.myid,
        option_name: change,
        elementInLayoutId: elementInLayoutId,
        uid: uid,
        directionIndex: direction,
        option_val: rect[change],
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param1)
    },
    activeEv(elementInLayoutId, uid, elementName, direction) {
      // 取消自动布局选中状态
      let oldIds = JSON.parse(JSON.stringify(this.ids))
      if (isExist(oldIds.elementInAutoLayoutId)) {
        this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", oldIds)
      }
      let activeLayoutTitle = {
        ...this.myid,
        directionIndex: direction,
        elementInLayoutId: elementInLayoutId
      }
      // this.clicked(null, elementInLayoutId, uid)
      if (!this.$store.state.states.alignHelperStatus) {
        let activeID = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          directionIndex: direction,
          elementInLayoutId: elementInLayoutId,
          elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
          path: this.myid.path
        }
        this.$store.commit("states/changeActiveID", activeID)
        // 先设置再取消自由布局选中 选中目的取消同级其他元素的选中态
        this.$store.dispatch(this.request_prefix + "/setActive", JSON.parse(JSON.stringify(this.myid)))
        this.$store.dispatch(this.request_prefix + "/unsetActive", JSON.parse(JSON.stringify(this.myid)))
        this.$store.dispatch(this.request_prefix + "/changeLayoutTitleActive", activeLayoutTitle)
        this.$store.commit("states/changeElementType", elementName)
      } else {
        this.$store.commit(this.request_prefix + "/ENABLE_ACTIVE", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id
        })
      }
      // 重新获取父元素的宽度, 要考虑缩放下面真实的宽度
      this.getParentW = this.$el.parentNode?.getBoundingClientRect()?.width / this.zoom
    },
    deactive(elementInLayoutId, uid, elementName, direction) {
      let disableActiveLayoutTitle = {
        ...this.myid,
        directionIndex: direction == "top" ? 0 : direction == "bottom" ? 1 : direction == "left" ? 2 : 3,
        elementInLayoutId: elementInLayoutId
      }
      this.$store.dispatch(this.request_prefix + "/layoutTitleDisableActive", disableActiveLayoutTitle)
    },
    delElementEv(args, elementInLayoutId, uid) {
      let param = {
        ...this.myid,
        elementInLayoutId,
        uid
      }
      this.$store.commit("states/changeElementType", null)
      this.$store.dispatch(this.request_prefix + "/delLayoutElement", param)
    },
    // 辅助线回调事件
    getRefLineParams(params, index) {
      const { vLine, hLine } = params
      let id = 0
      this.lineList[index].vLine = vLine.map(item => {
        item["id"] = ++id
        return item
      })
      this.lineList[index].hLine = hLine.map(item => {
        item["id"] = ++id
        return item
      })
    },
    judgeIsShow(data) {
      let tf = false
      data.forEach((item, index) => {
        if (item.isShow) {
          tf = true
        }
      })
      return tf
    },
    changeHeightMouseDownEv(ev, index) {
      this.resizingTitle = true
      this.resizingTitleIndex = index
      this.initOtherContentH = ev.screenY
      this.initOtherContentW = ev.screenX
    },
    changeHeightDarg: _throttle(function (ev, directionIndex, type) {
      this.changeHeightMouseUpEv(ev, directionIndex, type)
    }, 100),
    // 改变tab 最外层那个容器的尺寸
    changeHeightMouseUpEv(ev, directionIndex, type, isStop) {
      let curTitleOptions = this.options.titleOptions[directionIndex]
      let titleOptionDir = type
      if (titleOptionDir === "top" || titleOptionDir === "bottom") {
        const endY = ev.screenY
        const newH = parseInt((endY - this.initOtherContentH) / this.zoom)
        this.initOtherContentH = endY
        const param = {
          ...this.ids,
          directionIndex,
          changingTitleElement: true
        }
        const newVal = titleOptionDir === "top" ? curTitleOptions.height + newH : curTitleOptions.height - newH
        this.$changeOptionsEV(newVal, "height", false, false, param, true)
      } else if (titleOptionDir === "left" || titleOptionDir === "right") {
        const endX = ev.screenX
        const newW = parseInt((endX - this.initOtherContentW) / this.zoom)
        this.initOtherContentW = endX
        const param = {
          ...this.ids,
          directionIndex,
          changingTitleElement: true
        }
        const newVal = titleOptionDir === "left" ? curTitleOptions.width + newW : curTitleOptions.width - newW
        this.$changeOptionsEV(newVal, "width", false, false, param, true)
      }
      if (isStop) {
        this.resizingTitle = false
        this.resizingTitleIndex = null
      }
    },
    initFetchIds() {
      const { appId, pageId, restDataUrl, typeVal, websiteId, wfwfid } = this.options.myFetchParam
      const { pageId: _pageId, wfwfid: _wfwfid, websiteId: _websiteId } = this.$store.state.states.getDataPageIds
      this.appId = appId
      this.pageId = this.myid.pageId || _pageId
      this.restDataUrl = restDataUrl
      this.typeVal = typeVal
      this.websiteId = _websiteId
      this.wfwfid = _wfwfid
      if (pageId !== _pageId || wfwfid !== _wfwfid || websiteId !== _websiteId) {
        this.$changeOptionsEV(
          {
            typeVal: typeVal,
            restDataUrl: restDataUrl,
            pageId: this.pageId,
            wfwfid: this.wfwfid,
            websiteId: this.websiteId,
            appId
          },
          "myFetchParam",
          false,
          null,
          {
            rect_id: this.myid.rect_id,
            container_id: this.myid.container_id
          },
          true
        )
      }
    },
    getUpdateData(initType) {
      // 首次添加自由布局，没有分类信息，需要先获取分类，走全流程查询
      if (!this.restDataUrl) {
        this.asyncUpdateComponent(JSON.parse(JSON.stringify(this.options)))
      } else {
        this.timerUpdate(initType)
      }
    },
    initDataPageIds(newParam) {
      const dataPageIds = this.$store.state.states.getDataPageIds
      console.log("getDataPageIds", dataPageIds)
      const param = { ...dataPageIds, ...newParam }
      if (!!newParam) {
        Object.keys(newParam).forEach(key => (param[key] === newParam[key] ? "" : param[key] === newParam[key]))
        this.$store.commit("states/updateDataPageIds", param)
      }
      return param
    },
    async timerUpdate(initType) {
      initType = initType ? initType : "all"
      const updateLayoutData = new UpdateLayoutData(this)
      const menus =
        this.request_prefix === "bigScreen"
          ? this.$store.state.bigScreenMenu.menu.children.find(it => it.name === "基础").children
          : this.$store.state.menu.menu.children[1].children
      const rectAttr = this.options
      if (window.chartEventBus) {
        this.handleSearchValue()
      }
      // 把分类id存起来，列表页字段匹配重新响应数据需要
      const typeId = this.listPageTypeId && initType !== "activeIndex"
              ? this.listPageTypeId
              : initType !== "all"
              ? this.currentNavMenuValue
              : ""
      this.initDataPageIds({
        typeId,
        typeIds: this.typeIdsArr,
        relIds: this.relIdsArr,
        isOr: this.isOrBool,
        groupTypeId: this.groupTypeId,
      })
      const { completeData, drawLayoutAlready, totalRecords, pageSize } =
        await updateLayoutData.upDateRect({
          initType,
          activeIndex: rectAttr.activeIndex,
          pageNum: initType !== "all" ? this.currentPageNum : "", // 第一次初始化的时候不需要传
          typeId: typeId,
          sortRule: this.sortRule,
          searchValue: this.searchValue,
          typeIds: this.typeIdsArr,
          relIds: this.relIdsArr,
          isOr: this.isOrBool,
          groupTypeId: this.groupTypeId,
          searchKey: this.searchKey,
          isGroupSearch: this.isGroupSearch,
          isGroupSearchInit: this.isGroupSearchInit,
          groupSearchInitKeys: this.groupSearchInitKeys,
          groupSearchEngineInstanceId: this.groupSearchEngineInstanceId,
          dateVal: this.dateValStr,
          rectAttr: { options: rectAttr },
          cacheDataTypes: this.cacheDataTypes,
          restDataUrl: this.restDataUrl,
          categoryMode: this.categoryMode,
          renderModel: rectAttr?.pluginName?.includes('renderTypeCol') ? 'type' : 'data',
          wholeDataTypes: this.wholeDataTypes,
          ids: {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id,
            elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
            path: this.myid.path
          },
          dataCenterContent: this.dataCenterContent,
          addCb: param => {
            this.$store.dispatch(this.request_prefix + "/addComponentInLayout", param)
          },
          hideComponentCb: (param, opacity, display) => {
            if (!opacity && !display) {
              // 把透明度重置为1
              param.option_name = "opacity"
              param.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
            param.option_name = "display"
            param.option_val = "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            // param.option_name = "opacity"
            // param.option_val =  0
            // this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          showComponentCb: (param, opacity, display) => {
            if (!opacity && !display) {
              // 把透明度重置为1
              param.option_name = "opacity"
              param.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
            param.option_name = "display"
            param.option_val = "block"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            // param.option_name = "opacity"
            // param.option_val = opacity !== undefined ? opacity : 100
            // this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          updateCb: (completeparam, opacity, display) => {
            let completeParamClone = Object.assign({}, completeparam)
            if (!opacity && !display) {
              // 把透明度重置为1
              completeParamClone.option_name = "opacity"
              completeParamClone.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
            }
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            completeParamClone.option_name = "display"
            const noEmpty = completeparam.option_val !== "" && isExist(completeparam.option_val)
            completeParamClone.option_val = noEmpty ? "block" : "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
            // completeParamClone.option_name = "opacity"
            // completeParamClone.option_val = opacity !== undefined ? opacity : 100
            // this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
          },
          delElementCb: (ids, opacity) => {
            // this.$store.dispatch(this.request_prefix + "/delLayoutElement", ids)
            let completeparam = Object.assign({}, ids)
            completeparam.option_name = "display"
            completeparam.option_val = "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            if (!opacity) {
              // 把透明度重置为1
              completeparam.option_name = "opacity"
              completeparam.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            }
            // completeparam.option_name = "opacity"
            // completeparam.option_val = 0
            // this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
          },
          componentBoxUpdateCb: ({ url, dataId, uid, pageType }) => {
            const param = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
              path: this.myid.path,
              uid: uid,
              option_val: url,
              option_name: "componentBoxOptions-dataUrl"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
            const dataIdParam = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
              path: this.myid.path,
              uid: uid,
              option_val: dataId,
              option_name: "componentBoxOptions-dataId"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", dataIdParam)
            const pageTypeParam = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
              path: this.myid.path,
              uid: uid,
              option_val: pageType,
              option_name: "componentBoxOptions-pageType"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", pageTypeParam)
          },
          componentBoxUpdateOpacity: ({ opacity, uid }) => {
            const param = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
              path: this.myid.path,
              uid: uid,
              option_val: opacity,
              option_name: "componentBoxOptions-opacity"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
          },
          updateEleCb: (val, content_name, deep, deepName, ids) => {
            this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
          }
        })
      // 只有页面初始化的时候执行一次
      if (initType === "all") {
        this.initTitleOptionsAllComponents(rectAttr, this.restUrl, totalRecords, pageSize)
      }
      if (initType === "pagination" || initType === "navMenu" || initType === "activeIndex") {
        // 找到当前自由布局组件中分页组件的位置
        const result = findTabs(
          rectAttr,
          {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id,
            elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
            path: this.myid.path
          },
          "pagination"
        )
        if (result) {
          const { directionIndex, elementInLayoutId } = result
          this.initPaginationData(directionIndex, elementInLayoutId, totalRecords, pageSize)
        }
      }
      if (this.currentNavMenuValue) {
        const breadCrumbsData = await this.getBreadCrumbsData(this.currentNavMenuValue)
        if (breadCrumbsData) {
          // 如果当前返回了breadCrumbsData的值，则需要初始化面包屑组件
          // 找到当前自由布局组件中面包屑组件的位置
          const result = findTabs(
            rectAttr,
            {
              container_id: this.myid.container_id,
              rect_id: this.myid.rect_id,
              elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
              path: this.myid.path
            },
            "breadCrumbs"
          )
          if (result) {
            const { directionIndex, elementInLayoutId } = result
            this.initBreadCrumbsData(directionIndex, elementInLayoutId, this.restUrl, breadCrumbsData)
          }
        }
      }
      updateLayoutData.startUpdateLayout(completeData, drawLayoutAlready, menus)
      if (this.options.turnOnScroll) {
        this.reset()
      }
    },
    async timerUpdateNew(plugin) {
      let restDataUrl = plugin.restDataUrl
      restDataUrl = replaceUrlParam(restDataUrl, "p2", this.pageSize)
      const updateLayoutData = new UpdateLayoutData(this)
      const menus =
        this.request_prefix === "bigScreen"
          ? this.$store.state.bigScreenMenu.menu.children.find(it => it.name === "基础").children
          : this.$store.state.menu.menu.children[1].children
      const { completeData, drawLayoutAlready, totalRecords, pageSize } =
        await updateLayoutData.upDateRect({
          pageNum: plugin.params.p, // 第一次初始化的时候不需要传
          typeId: plugin.params.t,
          sortRule: plugin.sortRule,
          searchValue: plugin.params.sw,
          typeIds: plugin.params.typeIds,
          relIds: plugin.params.relIds,
          isOr: plugin.params.isOr,
          groupTypeId: plugin.params.groupTypeId,
          searchKey: this.searchKey,
          isGroupSearch: this.isGroupSearch,
          isGroupSearchInit: this.isGroupSearchInit,
          groupSearchInitKeys: this.groupSearchInitKeys,
          groupSearchEngineInstanceId: this.groupSearchEngineInstanceId,
          dateVal: this.dateValStr,
          rectAttr: this.options,
          cacheDataTypes: this.cacheDataTypes,
          restDataUrl: restDataUrl,
          categoryMode: this.categoryMode,
          renderModel: this.options?.pluginName?.includes('renderTypeCol') ? 'type' : 'data',
          wholeDataTypes: this.wholeDataTypes,
          ids: {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id,
            elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
            path: this.myid.path
          },
          dataCenterContent: this.dataCenterContent,
          addCb: param => {
            this.$store.dispatch(this.request_prefix + "/addComponentInLayout", param)
          },
          hideComponentCb: (param, opacity, display) => {
            if (!opacity && !display) {
              // 把透明度重置为1
              param.option_name = "opacity"
              param.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
            param.option_name = "display"
            param.option_val = "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            // param.option_name = "opacity"
            // param.option_val =  0
            // this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          showComponentCb: (param, opacity, display) => {
            if (!opacity && !display) {
              // 把透明度重置为1
              param.option_name = "opacity"
              param.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            }
            param.option_name = "display"
            param.option_val = "block"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
            // param.option_name = "opacity"
            // param.option_val = opacity !== undefined ? opacity : 100
            // this.$store.dispatch(this.request_prefix + "/changeLayoutOption", param)
          },
          updateCb: (completeparam, opacity, display) => {
            let completeParamClone = Object.assign({}, completeparam)
            if (!opacity && !display) {
              // 把透明度重置为1
              completeParamClone.option_name = "opacity"
              completeParamClone.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
            }
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            completeParamClone.option_name = "display"
            const noEmpty = completeparam.option_val !== "" && isExist(completeparam.option_val)
            completeParamClone.option_val = noEmpty ? "block" : "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
            // completeParamClone.option_name = "opacity"
            // completeParamClone.option_val = opacity !== undefined ? opacity : 100
            // this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeParamClone)
          },
          delElementCb: (ids, opacity) => {
            // this.$store.dispatch(this.request_prefix + "/delLayoutElement", ids)
            let completeparam = Object.assign({}, ids)
            completeparam.option_name = "display"
            completeparam.option_val = "none"
            this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            if (!opacity) {
              // 把透明度重置为1
              completeparam.option_name = "opacity"
              completeparam.option_val = 100
              this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
            }
            // completeparam.option_name = "opacity"
            // completeparam.option_val = 0
            // this.$store.dispatch(this.request_prefix + "/changeLayoutOption", completeparam)
          },
          componentBoxUpdateCb: ({ url, dataId, uid, pageType }) => {
            const param = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
              path: this.myid.path,
              uid: uid,
              option_val: url,
              option_name: "componentBoxOptions-dataUrl"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
            const dataIdParam = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
              path: this.myid.path,
              uid: uid,
              option_val: dataId,
              option_name: "componentBoxOptions-dataId"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", dataIdParam)
            const pageTypeParam = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
              path: this.myid.path,
              uid: uid,
              option_val: pageType,
              option_name: "componentBoxOptions-pageType"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", pageTypeParam)
          },
          componentBoxUpdateOpacity: ({ opacity, uid }) => {
            const param = {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
              path: this.myid.path,
              uid: uid,
              option_val: opacity,
              option_name: "componentBoxOptions-opacity"
            }
            this.$store.dispatch(this.request_prefix + "/updateColsOption", param)
          },
          updateEleCb: (val, content_name, deep, deepName, ids) => {
            this.$changeOptionsEV(val, content_name, deep, deepName, ids, true)
          }
        })
        if (typeof plugin.initCxPaginationData === "function") plugin.initCxPaginationData(totalRecords, pageSize)
        // if (typeof plugin.initCxCalendarData === "function" && (selectedDates.length > 0 || selectedDateMap.length > 0)) plugin.initCxCalendarData(selectedDates, selectedDateMap)
        updateLayoutData.startUpdateLayout(completeData, drawLayoutAlready, menus)
        if (this.options.turnOnScroll) {
          this.reset()
        }
    },
    async asyncUpdateComponent(options) {
      // 搜索插件中的自由布局组件不调用rest-classify接口
      if (options.noCacheComponent && !options.multiImageDetail && !this.options?.pluginName?.includes("searchComponentPlugin")) {
        const { pageId, wfwfid, websiteId, appId } = this.$store.state.states.getDataPageIds
        // 判断当前页面类型是否是列表页
        if (this.$store.state[this.request_prefix].type === "listPage") {
          // 判断是否是预设组件
          const rectAttr = this.getAttrById.call(
            this,
            this.$store.state[this.request_prefix],
            {
              container_id: this.myid.container_id,
              rect_id: this.myid.rect_id
            },
            "rect"
          )
          if (rectAttr.preComponent && appId !== options.appId) {
            this.$changeOptionsEV(appId, "appId", false, null, this.myid, true)
          }
        }
        let restDataUrl1 = ""
        if (!this.options.appId && this.options.myFetchParam && this.options.myFetchParam.restDataUrl) {
          restDataUrl1 = this.options.myFetchParam.restDataUrl
          //  当options中appid不存在是，获取 myFetchParam 中 restDataUrl 地址中的appid
          let arr1 = this.options.myFetchParam.restDataUrl.split("e=")
          if (arr1 && arr1.length > 1 && arr1[1]) {
            let appId1 = arr1[1].split("&")[0]
            this.$changeOptionsEV(appId1, "appId", false, null, {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id
            }, true)
          }
        }

        const { engineInstanceId, cacheDataTypes, restDataUrl, restUrl, engineInstanceAppId, engineInstance, generalDataTypes, dataCenterContent } =
          await getAppointCacheData.call(this, pageId, wfwfid, websiteId, this.options.appId, { useSubPageQuery: options.useSubPageQuery, selectedDetailParam: this.options.selectedDetailParam })
        this.cacheDataTypes = cacheDataTypes
        this.wholeDataTypes = generalDataTypes
        this.restDataUrl = this.options.appId ? restDataUrl : restDataUrl1
        this.restUrl = restUrl
        this.dataCenterContent = dataCenterContent
        // 将接口返回来的状态写入options中
        if (engineInstance) {
          let curIds = {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id
          }
          this.$changeOptionsEV(
            [
              engineInstance.checkIp,
              engineInstance.openSensitiveWords,
              engineInstance.deliverMhParams,
              engineInstance.linkNoProxy,
              engineInstance.id
            ],
            ["checkIp", "openSensitiveWords", "deliverMhParams", "linkNoProxy","engineInstanceId_10"],
            false,
            null,
            curIds,
            true
          )
        }
        if (
          restUrl &&
          restUrl.data &&
          restUrl.data.data &&
          restUrl.data.data.engineInstance &&
          this.options.appId === appId
        ) {
          let name =
            getHtmlPlainText(restUrl.data.data.engineInstance.appName) ||
            getHtmlPlainText(restUrl.data.data.engineInstance.name)
          this.$store.commit("states/changeSubPageName", name)
          if (options.name !== restUrl.data.data.engineInstance.appName) {
            this.$changeOptionsEV(name, "name", false, null, {
              rect_id: this.myid.rect_id,
              container_id: this.myid.container_id,
              elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
              path: this.myid.path
            }, true)
          }
        }
        // 上传的系统样式切换后publicId不对应 如不同在此处重新赋值
        let publicId = restUrl?.data?.data?.engineInstance?.publicId
        if (publicId && options.publicId !== publicId) {
          this.$changeOptionsEV(publicId, "publicId", false, null, {
            rect_id: this.myid.rect_id,
            container_id: this.myid.container_id,
            elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
            path: this.myid.path
          }, true)
        }
        this.$changeOptionsEV(engineInstanceId, "engineInstanceId", false, null, {
          rect_id: this.myid.rect_id,
          container_id: this.myid.container_id,
          elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
          path: this.myid.path
        }, true)
        this.$changeOptionsEV(engineInstanceAppId, "engineInstanceAppId", false, null, {
          rect_id: this.myid.rect_id,
          container_id: this.myid.container_id,
          elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
          path: this.myid.path
        }, true)
        await this.timerUpdate("all")
        if (this.isBigScreenPreview() && options.autoUpdate !== false) {
          this.reloadTimer = setInterval(
            this.timerUpdate,
            parseInt(options.updateTimer) * 1000 + Math.floor(Math.random() * 5000)
          )
        }
        const indexShowNum = restUrl?.data?.data?.engineInstance?.indexShowNum
        if (indexShowNum !== undefined) {
          if (indexShowNum !== this.pageSize) {
            // 没有闲时时间,延迟执行
            requestIdleCallback(() => {
              let pageSizeList = sessionStorage.getItem("pageSizeList") || "[]"
              pageSizeList = pageSizeList && JSON.parse(pageSizeList)
              const params = {
                appId: engineInstanceAppId,
                e: engineInstanceId,
                p2: this.pageSize,
                a: this.request_prefix === "appStage" ? 1 : 0
              }
              let index = pageSizeList.findIndex(item => item.appId === engineInstanceAppId)
              if (index === -1) pageSizeList.push(params)
              else pageSizeList.splice(index, 1, params)
              sessionStorage.setItem("pageSizeList", JSON.stringify(pageSizeList))
            })
          }
        }

        this.$eventBus.$emit('emptyLayoutRenderCompleted', {
          rect_id: this.myid.rect_id,
        })
      } else if(options.multiImageDetail) {
        await this.timerUpdate("pagination")
      }
    },
    cancleLodingStatu(){
       let isAddNewRect = sessionStorage.getItem("isAddNewRect")
       if(!isAddNewRect){
        return
       }
       // let isWaterFall = this.$store.state[this.request_prefix].page.isWaterFall  === 'waterFall' ? true : false
       // const parentClass = isWaterFall ?  "grid-item-content" :"layout-cell-container"
       const parentClass = "layout-cell-container"
       let parentNode = this.getParentNodeByClassName(this.$el, [], parentClass)
       if(parentNode.length === 0){
        return
       }
      // parentNode[0]?.removeAttribute("isLoading")
       let classList = parentNode[0]?.getElementsByClassName("loading-newRect")[0]?.classList
       if(classList){
         let loadingRect = document.getElementsByClassName("loading-newRect")
         loadingRect.length === 1 && sessionStorage.removeItem("isAddNewRect")
         classList.remove("loading-newRect")
       }
    },
    getOtherContentLRHeight() {
      // 需要判断'top'和'bottom'的内容是否显示，如果有的话，需要减去上下高度之和
      let lrHeight = 0
      if (this.options.titleOptions) {
        for (let i = 0; i < this.options.titleOptions.length; i++) {
          const titleOptionItem = this.options.titleOptions[i]
          if (titleOptionItem.elementOptions.length === 0) continue
          if (titleOptionItem.type === "top" || titleOptionItem.type === "bottom") {
            for (let j = 0; j < titleOptionItem.elementOptions.length; j++) {
              if (titleOptionItem.elementOptions[j].isShow) {
                lrHeight += this.options.titleOptionsHeight
                break
              }
            }
          }
        }
      }
      return lrHeight
    },
    /**
     * !!!!!初始化自由布局中的其他组件（分页、tabs分类、多级导航、垂直多级导航、标题、更多）
     * !!!!考虑到自由布局的使用场景不同，需要先判断组件是否存在，在进行对应的业务数据填充
     */
    initTitleOptionsAllComponents(rectAttr, restUrl, totalRecords, pageSize) {
      const AllOtherComponents = findAllComponentsInTitleOptions(rectAttr)
      if (AllOtherComponents.length === 0) return
      for (let i = 0; i < AllOtherComponents.length; i++) {
        switch (AllOtherComponents[i].type) {
          case "classification":
            // 初始化tabs组件
            this.initTabsData(AllOtherComponents[i].directionIndex, AllOtherComponents[i].elementInLayoutId, restUrl, rectAttr.multiImageDetail)
            break
          case "pagination":
            // 初始化分页组件
            this.initPaginationData(
              AllOtherComponents[i].directionIndex,
              AllOtherComponents[i].elementInLayoutId,
              totalRecords,
              pageSize
            )
            break
          case "more":
            // 初始化更多组件
            this.initMoreData(AllOtherComponents[i].directionIndex, AllOtherComponents[i].elementInLayoutId)
            break
          case "breadCrumbs":
            // 初始化面包屑组件
            this.initBreadCrumbsData(
              AllOtherComponents[i].directionIndex,
              AllOtherComponents[i].elementInLayoutId,
              restUrl
            )
            break
          case "navMenuVertical":
            // 初始化多级导航组件
            this.initNavMenuData(AllOtherComponents[i].directionIndex, AllOtherComponents[i].elementInLayoutId, restUrl)
            break
          case "navMenuVertical":
            // 初始化垂直多级导航组件
            this.initNavMenuData(AllOtherComponents[i].directionIndex, AllOtherComponents[i].elementInLayoutId, restUrl)
            break
        }
      }
    },
    // 请求数据完成后初始化tab组件
    initTabsData(directionIndex, elementInLayoutId, restUrl, multiImageDetail) {
      if (!restUrl && !multiImageDetail) return
      let tabsData = []
      if(restUrl && !multiImageDetail) {
        restUrl.data.data.generalDataTypes.forEach(item => tabsData.push({ id: item.publicId, name: item.name, backIconUrl: item.iconUrl, backActiveIconUrl: item.backgroundUrl }))
      }
      // 最大个数限制
      const elementOptions = this.options.titleOptions[directionIndex].elementOptions
      let tabs = undefined
      if (elementOptions.length > 0) {
        tabs = elementOptions.find(item => item.elementInLayoutId === elementInLayoutId)
      }
      if (tabs && tabs.options && tabs.options.isCustomTabsNum) {
        tabsData = tabsData.slice(0, tabs.options.maxLength)
      }
      // 同步分类的时候，需要把多余的row删除，不够的补上一行一列的容器
      const tabParams = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        elementInLayoutId: elementInLayoutId,
        directionIndex: directionIndex,
        maxLength: tabsData.length > 0 ? tabsData.length : 1, // tab的c长度不能为0
        isAsyncData: true,
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path
      }
      this.$store.dispatch(this.request_prefix + "/changeLayoutTabsLength", tabParams)
      let param = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "tabsList",
        option_val: tabsData,
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      recordOldSize.call(this, this.options)
      if (this.options.tabsList?.length !== tabsData?.length) {
        this.$changeOptionsEV(tabsData, "tabsList", false, null, {
          rect_id: this.myid.rect_id,
          container_id: this.myid.container_id,
          elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
          path: this.myid.path
        }, true)
      }
      if (this.options?.pluginName?.includes("fetch-twoTabsLayoutPlugin")) {
        this.$initPlugin(this.options?.pluginName)
      }
    },
    // 请求完数据后更新面包屑组件
    initBreadCrumbsData(directionIndex, elementInLayoutId, restUrl, breadCrumbsData) {
      let param = null
      let homePageName = ""
      let subPageName = this.$store.state.states.subPageName
      if (breadCrumbsData && breadCrumbsData?.data?.code === 1) {
        homePageName = breadCrumbsData.data?.data?.pageName //修改了接口，当前页面名称返回到获取面包屑接口中
        // 判断是初始化还是点击多级导航后的数据联动
        const sourceData = JSON.parse(
          JSON.stringify(this.options.titleOptions[directionIndex].elementOptions[elementInLayoutId].options.sourceData)
        )
        sourceData.splice(2) // 删除除前两个元素外的其他元素
        const crumbsData = breadCrumbsData.data.data.crumbs.map(item => ({
          label: item.name,
          value: item.id
        }))
        sourceData.push(...crumbsData)
        sourceData[0].label = homePageName ? homePageName : "首页"
        sourceData[1].label = subPageName ? subPageName : "图文"
        param = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          directionIndex: directionIndex,
          elementInLayoutId: elementInLayoutId,
          option_name: "sourceData",
          option_val: sourceData
        }
      } else {
        const homePageId = this.$store.state[this.request_prefix].page.homePageId
        const newUrl = replaceUrlParam(window.location.href, "p", homePageId)
        let defaultParam = restUrl.data.data.generalDataTypes[0] // 默认选中第一个分类，数据可能会没有分类
        // 现在没有地方取到应用名称，先暂时写死应用名称
        const sourceData = [
          {
            label: homePageName ? homePageName : "首页",
            path: newUrl
          },
          {
            label: subPageName ? subPageName : "图文"
          },
          {
            label: defaultParam?.name,
            value: defaultParam?.publicId
          }
        ]
        param = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          directionIndex: directionIndex,
          elementInLayoutId: elementInLayoutId,
          option_name: "sourceData",
          option_val: sourceData,
          elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
          path: this.myid.path
        }
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
    },
    // 当外部传入了typeId时，获取面包屑数据，兼容老数据处理
    async getBreadCrumbsData(typeId) {
      let engineId = this.restUrl?.data?.data?.engineInstance?.publicId
      return this.$API.queryCrumbData({
        typeId: typeId,
        e: engineId
      })
    },
    // 请求完数据后初始化分页组件
    initPaginationData(directionIndex, elementInLayoutId, totalRecords, pageSize) {
      // 每次数据重新请求后都需要初始化分页组件的数据
      if (this.isInitPaginationCurrentPageFlag) {
        let param = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          directionIndex: directionIndex,
          elementInLayoutId: elementInLayoutId,
          option_name: "value",
          option_val: 1,
          elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
          path: this.myid.path
        }
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
        this.isInitPaginationCurrentPageFlag = false
      }
      // 考虑空数据的情况
      totalRecords = totalRecords ? Number(totalRecords) : 0
      let param = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "total",
        option_val: totalRecords,
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      pageSize = pageSize ? Number(pageSize) : 0
      let param1 = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "pageSize",
        option_val: pageSize,
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param1)
    },
    // 请求数据完成后初始化多级导航
    initNavMenuData(directionIndex, elementInLayoutId, restUrl) {
      let showNavMenu = this.subPage.listPageSetting.showNavMenu
      // 展示自由布局左侧导航
      if (showNavMenu) {
        const param = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          directionIndex: 2,
          changingTitleElement: true
        }
        this.$changeOptionsEV(true, "isShow", false, false, param, true)
      }
      let navMenuData,
        targetData = []
      navMenuData = restUrl.data.data.generalDataTypes
      this.recursiveFindDataTypes(navMenuData, targetData)
      let param = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "selectOptions",
        option_val: targetData,
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      let valueParam = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "value",
        option_val: navMenuData[0]?.publicId,
        elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
        path: this.myid.path
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", valueParam)
    },
    // 递归找到数据分类层级
    recursiveFindDataTypes(navMenuData, targetData) {
      for (let key in navMenuData) {
        targetData.push({
          label: navMenuData[key].name,
          value: navMenuData[key].publicId,
          iconUrl: navMenuData[key].iconUrl,
          children: []
        })
        if (typeof navMenuData[key].subGeneralDataTypes == "object") {
          this.recursiveFindDataTypes(navMenuData[key].subGeneralDataTypes, targetData[key].children)
        }
      }
    },
    // 初始化修改更多按钮数据 兼容旧的更多按钮绑定了一个默认的链接地址
    initMoreData(directionIndex, elementInLayoutId) {
      const elementOptions = this.options.titleOptions[directionIndex].elementOptions
      if (elementOptions.length > 0) {
        const moreAttr = elementOptions.find(item => item.elementInLayoutId === elementInLayoutId)
        // 默认的更多按钮绑定了一个链接 在此处设为空
        if (
          moreAttr &&
          moreAttr.options &&
          moreAttr.options.linkUrl?.includes("undefined") &&
          moreAttr.options.linkAddress === "自定义"
        ) {
          let param = {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id,
            directionIndex: directionIndex,
            elementInLayoutId: elementInLayoutId,
            option_name: "linkUrl",
            option_val: "",
            elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
            path: this.myid.path
          }
          this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
          let param1 = {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id,
            directionIndex: directionIndex,
            elementInLayoutId: elementInLayoutId,
            option_name: "linkAddress",
            option_val: "默认",
            elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
            path: this.myid.path
          }
          this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param1)
        }
      }
    },
    async handleColsDragover(e, id) {
      let attribute = e.dataTransfer.getData("rectAttribute")
      let childItemInfo = sessionStorage.getItem("childItemInfo")
      this.isDragover = ""
      childItemInfo = JSON.parse(childItemInfo)
      if (childItemInfo.childItemName === "收藏") {
        e.stopPropagation()
        attribute = JSON.parse(attribute)
        const _attribute = await getSyetemModuleJson(attribute.encId)
        attribute = JSON.stringify(_attribute)
      }
      if (attribute) {
        attribute = JSON.parse(attribute)
        if (attribute.shape === "cxEditor") {
          const isAdmin = this.$store.state.states.managerType === 1 ? true : false
          if (!isAdmin) {
            // 如果是非管理员模式并且富文本组件拖拽到自由布局容器里，需要解析为普通文本组件 2023/08/04需求，https://sharewh2.xuexi365.com/share/41a72470-2cc1-4045-87df-35bbfc7fa3af?t=3
            const layoutUidMap = attribute?.options?.layoutUidMap
            attribute = text_children[0].attribute
            attribute.options.layoutUidMap = layoutUidMap
          }
        }
        attribute.options.filedMapping = {
          value: null,
          label: null,
          flag: false,
          checked: true
        }
        const preventComponentMap = [
          "cxautolayout", //自动布局组件
          "layoutcomponent", //布局组件
          "swiper" //轮播组件
        ]
        if (preventComponentMap.find(it => attribute.shape.toLowerCase().includes(it))) return
        e.cancelBubble = true
        this.$store.dispatch("menu/unsetActive", { id: "all" })
        // 针对自动布局模式下的组件 添加标识属性
        attribute.zIndex = 0
        //获取当前鼠标的left和top
        const { width, height } = attribute.options
        const { offsetWidth, offsetHeight } = e.target
        let [left, top] = [e.offsetX, e.offsetY]
        ;[attribute.options.left, attribute.options.top] = [left - width / 2, top - height / 2]

        const rightCheck = () => attribute.options.left + attribute.options.width > offsetWidth
        const bottomCheck = () => attribute.options.top + attribute.options.height > offsetHeight
        const leftCheck = () => attribute.options.left < 0
        const topCheck = () => attribute.options.top < 0
        while (rightCheck() || bottomCheck() || leftCheck() || topCheck()) {
          if (rightCheck()) {
            //处理右侧超出去的情况
            if (attribute.options.width <= offsetWidth) {
              attribute.options.left = offsetWidth - attribute.options.width
            } else {
              attribute.options.width = offsetWidth - attribute.options.left
            }
          }
          if (bottomCheck()) {
            //处理下侧超出去的情况
            if (attribute.options.height <= offsetHeight) {
              attribute.options.top = offsetHeight - attribute.options.height
            } else {
              attribute.options.height = offsetHeight - attribute.options.top
            }
          }
          if (leftCheck()) {
            //处理左侧超出去的情况
            attribute.options.left = 0
          }
          if (topCheck()) {
            //处理上侧超出去的情况
            attribute.options.top = 0
          }
        }

        let param = {
          ...this.myid,
          direction: id,
          elementOptions: attribute.options
        }
        this.$store.dispatch(this.request_prefix + "/addComponentInLayoutAround", param)
        // 激活当前组件
        let elementOptions = this.options.titleOptions[id].elementOptions
        let elementInLayoutId = elementOptions[elementOptions.length - 1]?.elementInLayoutId || 0
        this.$addHistory({
          type: "add",
          stateType: "addLayoutAroundElement",
          payload: {
            container_id: param.container_id,
            rect_id: param.rect_id,
            direction: param.direction,
            elementInLayoutId
          }
        })
        // 做一个延时，是为了改组件写进webJson中再执行
        this.activeEv(elementInLayoutId, undefined, attribute.shape, id)
        // 拖入组件到四遍栏时 重新提高通栏的层级
        this.setPageLayoutWrapZindex(true)
      }
    },
    // 设置外层页面布局的层级 当前的为最高
    setPageLayoutWrapZindex(show) {
      let parentNode = this.getParentNodeByClassName(this.$el, [], "page-layout-wrapper")
      if (parentNode.length === 0) {
        return
      }
      // 应要求，去掉选中 增高层级
      if (show) {
        parentNode[0].setAttribute("data-level", "top-level")
      } else {
        parentNode[0].removeAttribute("data-level")
      }
    },
    getParentNodeByClassName(e, res = [], parentClass) {
      const parentNode = e.parentNode
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        if ([].find.call(elClasslist, it => it === parentClass)) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getParentNodeByClassName(parentNode, res, parentClass)
        }
      } else {
        return res
      }
    },
    changeUid(content) {
      deepChangeUid(content)
    },
    otherMouseEnter(e) {
      e.target.classList.add("hover")
    },
    otherMouseLeave(e) {
      e.target.classList.remove("hover")
    },
    dragoverLeaveEv(e, index) {
      sessionStorage.removeItem("dropOverCell")
      this.isDragover = ""
    },
    dragoverEv(e, index) {
      let rectShape = localStorage.getItem("dragType")
      const disableShapes = [
        "cxPageLayout",
        "emptyLayoutComponent",
        "cxGaphic",
        "cxSystemText",
        "cxSystemNav",
        "cxSystemSearch",
        "swiperComponent",
        "loginComponent",
        "cxSystemLogin",
        "cxUserPortraits",
        "cxSystemAccordion"
      ]
      console.log(e.dataTransfer.setData)
      if (!disableShapes.includes(rectShape)) {
        e.dataTransfer.dropEffect = "copy"
        this.isDragover = index
      } else {
        e.dataTransfer.dropEffect = "none"
      }
    },
    reset() {
      this.isHover = false
      this._cancle()
      this._initMove()
    },
    _cancle() {
      cancelAnimationFrame(this.reqFrame || "")
    },
    enter() {
      if (this.hoverStopSwitch) this._stopMove()
    },
    leave() {
      if (this.hoverStopSwitch) this._startMove()
    },
    _move() {
      // 鼠标移入时拦截_move()
      if (this.isHover || this.preventScroll) return
      this._cancle() //进入move立即先清除动画 防止频繁touchMove导致多动画同时进行
      let target = this.layoutType === "col" ? "yPos" : "xPos"
      this.reqFrame = requestAnimationFrame(
        function () {
          const h = this.realBoxBase / 2
          let waitTime = this.options.waitTimeUnit ? this.options.waitTime : (this.options.waitTime || 0) * 1000
          if (this.direction === 1) {
            // 上
            if (Math.abs(this[target]) >= h) {
              this[target] = 0
            }
            this[target] -= this.step
          } else if (this.direction === 0) {
            // 下
            if (this[target] >= 0) {
              this[target] = h * -1
            }
            this[target] += this.step
          }
          this.setTransform()
          if (this.singleWaitTime) {
            clearTimeout(this.singleWaitTime)
          }
          if (this.realSingleStopHeight) {
            //是否启动了单行暂停配置
            if (Math.abs(this[target]) % this.realSingleStopHeight < this.step) {
              // 符合条件暂停waitTime
              this.singleWaitTime = setTimeout(() => {
                this._move()
              }, waitTime)
            } else {
              this._move()
            }
          } else {
            this._move()
          }
        }.bind(this)
      )
    },
    _initMove() {
      this.$nextTick(() => {
        this.copyHtml = "" //清空copy
        // 还原位置
        this.xPos = 0
        this.yPos = 0
        this.step = 1
        if (this.options.turnOnScroll) {
          this.ease = "linear"
          this.delay = 0
        } else {
          this.ease = "linear"
          this.delay = 400
          return
        }
        // 是否可以滚动判断
        if (!this.emptyData && !this.preventScroll) {
          let timer
          if (timer) clearTimeout(timer)
          this.copyHtml = this.$refs.slotList.innerHTML
          setTimeout(() => {
            const realBox = this.$refs.realBox
            this.realBoxBase =
              this.layoutType === "col" ? realBox.offsetHeight : realBox.offsetWidth
            const containerH = this.layoutType === "col" ? realBox.parentElement.offsetHeight : realBox.parentElement.offsetWidth
            // 以16.7ms一帧计算，滚动一屏需要的时间
            const count = (this.options.scrollSpeed || 6000) / 16.7
            this.step = Math.ceil(containerH / count)
            this._move()
          }, 100)
        } else {
          this._cancle()
          this.xPos = 0
          this.yPos = 0
          this.step = 1
        }
      })
    },
    _startMove() {
      this.isHover = false //开启_move
      this._move()
    },
    _stopMove() {
      this.isHover = true //关闭_move
      // 防止频频hover进出单步滚动,导致定时器乱掉
      if (this.singleWaitTime) clearTimeout(this.singleWaitTime)
      this._cancle()
    },
    async eventFunction(msg) {
      console.log("msg", msg)
      if (msg) {
        if (msg.hasOwnProperty('sortRule')) {
          // 排序相关的参数，一旦接了就是固化到当前组件了
          this.sortRule = msg.sortRule
        }
        if (msg.hasOwnProperty("typeId")) this.listPageTypeId = msg.typeId
        //多级筛选的参数
        if (msg.hasOwnProperty("typeIds")) this.typeIdsArr = msg.typeIds
        if (msg.hasOwnProperty("relIds")) this.relIdsArr = msg.relIds
        if (msg.hasOwnProperty("isOr")) this.isOrBool = msg.isOr
        if (msg.hasOwnProperty("groupTypeId")) this.groupTypeId = msg.groupTypeId ? JSON.stringify(msg.groupTypeId) : msg.groupTypeId
        // 搜索组件的参数
        if (msg.hasOwnProperty("searchValue")) this.searchValue = msg.searchValue
        if (this.typeIdsArr?.length) {
          this.listPageTypeId = ""
        }
        if (msg.hasOwnProperty("searchKey")) this.searchKey = msg.searchKey
        if (msg.hasOwnProperty("isGroupSearch")) this.isGroupSearch = msg.isGroupSearch
        if (msg.hasOwnProperty("isGroupSearchInit")) this.isGroupSearchInit = msg.isGroupSearchInit
        if (msg.hasOwnProperty("groupSearchInitKeys")) this.groupSearchInitKeys = msg.groupSearchInitKeys

        if (msg.hasOwnProperty("groupSearchEngineInstanceId"))
          this.groupSearchEngineInstanceId = msg.groupSearchEngineInstanceId
        if (msg.hasOwnProperty("dateVal")) this.dateValStr = msg.dateVal
        if (msg.hasOwnProperty("updateAll")) {
          this.asyncUpdateComponent(JSON.parse(JSON.stringify(this.options)))
          return
        }
        // 需要重置分页组件的当前页
        if (this.paginationDirectionIndex && isExist(this.paginationElementInLayoutId)) {
          let param = {
            container_id: this.myid.container_id,
            rect_id: this.myid.rect_id,
            directionIndex: this.paginationDirectionIndex,
            elementInLayoutId: this.paginationElementInLayoutId,
            option_name: "value",
            option_val: 1,
            elementInAutoLayoutId: this.myid.elementInAutoLayoutId,
            path: this.myid.path
          }
          this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
          this.isInitPaginationCurrentPageFlag = false
        }
        await this.timerUpdate("all")
      }
    },
    getRealSize(dom, sizeAttr) {
      if (!dom) return 0
      if (dom[sizeAttr] > 0) return dom[sizeAttr]
      return this.getRealSize(dom.parentNode, sizeAttr)
    },
    setTransform() {
      if(this.$refs.realBox) {
        this.$refs.realBox.style.transform = `translate(${this.xPos}px, ${this.yPos}px)`
      }
    },
    initSubPageDataGridData(plugin) {
      this.$changeOptionsEV(plugin.showDataGrid, "isShow", false, null, this.myid, true)
      this.timerUpdateNew(plugin)
    }
  },
  mounted() {
    this.$initPlugin(this.options?.pluginName)
    this.isMounted = true
    this.activeTabId = this.options.tabs ? this.options.tabs.filter(tab => tab.isActive)[0].id : ""
    const style = window.getComputedStyle(this.$el.parentNode, null)
    if (style.getPropertyValue('height')?.endsWith('%') && this.$el.parentNode.offsetHeight === 0) {
      // 高度是百分比高度，并且真实高度还是0, 说明是横向标签或者竖向标签布局中并且不是第一个标签下的自由布局，向上回溯找到第一个有真实高度的dom
      const realHeight = this.getRealSize(this.$el.parentNode, 'offsetHeight')
      this.getParentH = parseFloat(style.getPropertyValue("height")) / 100 * realHeight
    } else {
      this.getParentH = parseInt(style.getPropertyValue("height"), 10) - this.getOtherContentLRHeight()
    }
    if (style.getPropertyValue('width')?.endsWith('%') && this.$el.parentNode.offsetWidth === 0) {
      const realWidth = this.getRealSize(this.$el.parentNode, 'offsetWidth')
      this.getParentW = parseFloat(style.getPropertyValue("width")) / 100 * realWidth
    } else {
      this.getParentW = parseInt(style.getPropertyValue("width"), 10)
    }
    if (window.chartEventBus) {
      this.addChartEvent()
    }
    this.$nextTick(()=>{
      this.cancleLodingStatu()
    })
    this.asyncUpdateComponent(JSON.parse(JSON.stringify(this.options)))
    this.$eventBus.$on(`update-layout-data-eventBus-${this.myid.container_id}-${this.myid.rect_id}`, this.eventFunction)
    if (this.options.appId) {
      let subPageSettings = window.localStorage.getItem(
        "subPageSetting-" + this.options.appId + "-" + this.request_prefix
      )
      this.subPage = subPageSettings && subPageSettings !== "undefined" ? JSON.parse(subPageSettings) : null
    }
    //执行滚动
    setTimeout(() => {
      this._initMove()
    }, 1000)
    // 处理脏数据
    this.clearDirtyRect()
  },
  beforeCreate() {
    this.reqFrame = null // move动画的animationFrame定时器
    this.singleWaitTime = null // single 单步滚动的定时器
    this.isHover = false // mouseenter mouseleave 控制this._move()的开关
    this.ease = "ease-in"
  },
  beforeDestroy() {
    this.$eventBus.$off(
      `update-layout-data-eventBus-${this.myid.container_id}-${this.myid.rect_id}`,
      this.eventFunction
    )
    clearInterval(this.reloadTimer)
    this.reloadTimer = null
    this._cancle()
    clearTimeout(this.singleWaitTime)
  }
}
</script>

<style scoped>
.custom-handle {
  display: none;
  width: 100%;
  position: absolute;
  border-bottom:1px dashed var(--themeColor);
  cursor: move;
  z-index: 1;
}
.custom-handle::drag * {
  display: none;
}
.other_content:hover .custom-handle,
.other_content .custom-handle.show {
  display: block;
}
.custom-handle::after {
  position: absolute;
  border-radius: 4px;
  background-color: var(--themeColor);
  content: "";
}
.custom-handle-top::after,
.custom-handle-bottom::after {
  width: 20px;
  height: 6px;
  left: 50%;
  margin-left: -10px;
  top: -2px;
}
.custom-handle-left::after,
.custom-handle-right::after {
  width: 6px;
  height: 20px;
  top: 50%;
  margin-top: -10px;
  left: -2px;
}
.size-popover {
  position: absolute;
  background: rgba(24, 30, 51, 0.8);
  border-radius: 4px;
  z-index: 10;
  font-size: 12px;
  line-height: 17px;
  padding: 5px 12px;
  color: #fff;
  white-space: nowrap;
}
.custom-handle-top .size-popover {
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
}
.custom-handle-bottom .size-popover {
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
}
.custom-handle-left .size-popover {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -30px;
}
.custom-handle-right .size-popover {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: -30px;
}
.bv-example-row {
  padding: 0;
}
.headerBox {
  width: 100%;
  height: 50px;
  position: relative;
}
.other_content {
  position: relative;
  z-index: 2;
  /*处理某些情况下布局宽度减小，造成更多按钮超出去的情况*/
  overflow-x: visible;
}
.other_content.hover {
  outline: 1px dashed var(--themeColor);
  z-index: 4;
}
::v-deep .el-drawer__body .other_content {
  display: block !important;
}
.ref-line {
  position: absolute;
  background-color: rgb(255, 0, 204);
  z-index: 9999;
}

.v-line {
  width: 1px;
}

.h-line {
  height: 1px;
}
.content_otherLR {
  display: flex;
  position: relative;
}
::v-deep .el-drawer__wrapper {
  position: absolute;
}
::v-deep .v-modal {
  position: absolute;
}
.content_center {
  flex: 1;
  height: 100%;
  position: relative;
}
.content_center1 {
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.realBox {
  width: 100%;
  height: 200%;
  display: flex;
  overflow: hidden;
}
.content_center_div {
  overflow: hidden;
  width: 100%;
  height: 50%;
}
.content_center_div1 {
  overflow: hidden;
  width: 100%;
  height: 50%;
}
</style>
